import { kMaxLength } from "buffer";
import dayjs from "dayjs";
import ExcelJS from "exceljs"
import moment from "moment";
//const ExcelJS = require('exceljs');
//import { FileSaver } from 'file-saver';
const FileSaver = require('file-saver');


//组件 DownloadExcel 
const DownloadExcel = async (rows: any, apiId: any, queryCriteria?: any) => {

    if (rows.length === 0 || typeof rows === "undefined") return
    //供应商申购单
    if (apiId === "suPurchaseApplication") {
        console.log(rows.supplierName);
        console.log("该内容是" + rows.supplierName);
        console.log(rows);
        let abc: Array<any> = []
        let newData: Array<any> = []
        //修改rows.dept数据结构
        rows.depts.forEach((item: any) => {
            let oider = {
                id: item.productId,
                productName: item.product.productName,
                depts: [],
                total: 0
            }
            if (abc.indexOf(item.productId) === -1) {
                abc.push(item.productId)

                newData.push(oider)


            }
            newData.forEach((v3: any) => {
                if (v3.id === item.productId) {
                    oider.total += item.payCount
                    v3.depts.push(item)
                }
            })
        })
        // 数据
        let data = rows.depts
        // console.log("获取表格内容", data)
        let dataTable: Array<any> = [];
        let dataAB: Array<any> = []
        data.map((item: any) => {
            if (dataAB.indexOf(item.deptId) === -1) {
                dataAB.push(item.deptId)
            }
        })
        dataAB.forEach((v) => {
            let order = {
                header: null,
                key: v,
                width: 20
            }
            data.forEach((item: any) => {
                if (v === item.deptId) {
                    order.header = item.dept.deptName
                }
            })
            dataTable.push(order)
        })

        // dataTable.push({ header: item.dept.deptName, key: item.deptId, width: 20 })

        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('申购订单', {
            pageSetup: { paperSize: 9, orientation: 'landscape' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */
        const dataA = [{ header: '产品名称', key: 'productName', width: 25 },
        { header: '单位', key: 'productUnitName', width: 25 },
        ...dataTable,
        { header: '合计', key: 'total', width: 15 }]
        worksheet.columns = dataA

        // 添加行数据
        let aa: Array<any> = []
        let bb: Array<any> = []
        newData.forEach((item) => {

            item.depts.forEach((item1: any) => {

                if (aa.indexOf(item.id) === -1) {
                    aa.push(item.id)
                    let oider = {
                        id: item.id,
                        productUnitName: item1.product.productUnit.productUnitName,
                        productName: item.productName,
                        [item1.deptId]: item1.payCount,
                        total: 0,
                    }
                    bb.push(oider)
                }
                bb.forEach((item2: any) => {

                    if (item2.id === item1.productId) {
                        item2[item1.deptId] = item1.payCount
                        item2.total += item1.payCount
                    }
                })
            })

        });
        // worksheet.addRow(["xxx"]);
        worksheet.addRows(bb);
        worksheet.insertRow(1, ["xxx"]);
        const titlerow = worksheet.getRow(1);
        titlerow.getCell(1).value = `致:${rows.supplierName}`; // A1 的值设置为"销售报表"
        // // 设置标题行的行高
        titlerow.height = 40;


        // 设置字体
        worksheet.getCell('A1').font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };
        //  // 合并单元格
        worksheet.mergeCells('A1:J1');

        for (var i = 1; i <= dataA.length; i++) {

            // 设置每个单元格的周围设置单个细边框
            if (i === 1) {
                worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } };
            }
            else {

                if (i === dataA.length) {

                    worksheet.getRow(i).height = 20;

                }
                //设置边框
                worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('B' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('C' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('D' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('E' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('F' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('G' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('H' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('I' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('J' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            }
            //设置字体
            worksheet.getCell('A' + i + '').font = { name: '宋体', family: 4, size: 15, bold: true };
            worksheet.getCell('B' + i + '').font = { name: '宋体', family: 4, size: 15, bold: true };
            worksheet.getCell('C' + i + '').font = { name: '宋体', family: 4, size: 15, bold: true };
            worksheet.getCell('D' + i + '').font = { name: '宋体', family: 4, size: 15, bold: true };
            worksheet.getCell('E' + i + '').font = { name: '宋体', family: 4, size: 15, bold: true };



            //  居中对齐并自动换行
            worksheet.getCell('A' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('B' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('C' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('D' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('E' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
        }

        // 居中对齐并自动换行
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
        //  设置页脚(默认居中)
        // worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";

        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '申购表.xlsx');
        })

    }


    //部门申购单
    if (apiId === "dePurchaseApplication") {
        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('部门下单表', {
            pageSetup: { paperSize: 9, orientation: 'landscape' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };
        // 添加列标题并定义列键和宽度
        worksheet.columns = [
            { header: '品名', key: "productName", width: 16 },
            { header: '数量', key: "payCount", width: 30 },
            { header: '单位', key: "productUnitName", width: 16 },
        ];
        // 数据
        let data = rows.products;
        worksheet.addRows(data);
        worksheet.insertRow(1, [rows.deptName]);
        worksheet.insertRow(2, ["以下品种需" + rows.orderTime + "下单"]);
        worksheet.insertRow(3, [rows.classificationWarehouseName]);

        const titlerowOne = worksheet.getRow(1);
        titlerowOne.height = 20;
        const titlerowTwo = worksheet.getRow(2);
        titlerowTwo.height = 20;
        const titlerowThree = worksheet.getRow(3);
        titlerowThree.height = 20;

        // 设置字体
        worksheet.getCell('A1').font = {
            name: '宋体',
            family: 5,
            size: 10,
            bold: true
        };
        worksheet.getCell('A2').font = {
            name: '宋体',
            family: 4,
            size: 10,
            bold: true
        };
        worksheet.getCell('A3').font = {
            name: '宋体',
            family: 3,
            size: 10,
            bold: true
        };
        //  // 合并单元格
        worksheet.mergeCells('A1:C1');
        worksheet.mergeCells('A2:C2');
        worksheet.mergeCells('A3:C3');


        for (var i = 1; i <= data.length; i++) {

            // 设置每个单元格的周围设置单个细边框
            if (i === 1) {
                worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } };
            }
            else {

                if (i === data.length) {

                    worksheet.getRow(i).height = 20;

                }
                //设置边框
                worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('B' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('C' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('D' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('E' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('F' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('G' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('H' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('I' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell('J' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            }
            //设置字体
            worksheet.getCell('A' + i + '').font = { name: '宋体', family: 4, size: 15, bold: true };
            worksheet.getCell('B' + i + '').font = { name: '宋体', family: 4, size: 15, bold: true };
            worksheet.getCell('C' + i + '').font = { name: '宋体', family: 4, size: 15, bold: true };
            worksheet.getCell('D' + i + '').font = { name: '宋体', family: 4, size: 15, bold: true };
            worksheet.getCell('E' + i + '').font = { name: '宋体', family: 4, size: 15, bold: true };



            //居中对齐并自动换行
            worksheet.getCell('A' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('B' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('C' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('D' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('E' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
        }




        // 居中对齐并自动换行
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };



        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '部门申购表.xlsx');
        })
    }


    //票据报表
    if (apiId === "moonReport") {
        console.log("该内容是" + apiId);
        console.log(rows);


        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('票据报表', {
            pageSetup: { paperSize: 9, orientation: 'landscape' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度
        worksheet.columns = [
            { header: '', width: 25 },
            { header: '', width: 25 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 20 },
            { header: '', width: 20 },
            { header: '', width: 20 },
            { header: '', width: 10 },
        ];
        // 数据
        let data = rows;
        //总兑换数量
        let totalChanged = 0;
        //总售出数量
        let totalSolded = 0;
        //折后价
        let totalAmount = 0;
        //原价（售出）
        let toTalOriginAmount = 0;
        //原价（兑换）

        let toTalOriginExAmount = 0;
        let tatalSum = 0;

        let dataTable: any = []
        data.map((item: any) => {
            dataTable.push([
                item.branchStoreName, item.moonType, item.disCount, item.sum, item.solded, item.changed, item.originAmount, item.originExAmount, item.amount
            ])
            if (item.changed) totalChanged += item.changed
            if (item.solded) totalSolded += item.solded;
            if (item.amount) totalAmount += item.amount;
            if (item.originAmount) toTalOriginAmount += item.originAmount;
            if (item.originExAmount) toTalOriginExAmount += item.originExAmount;
            if (item.sum) tatalSum += item.sum;


        })

        // 将数据插入
        // queryCriteria
        worksheet.addRow([`${queryCriteria.timeNameA}: ${moment(queryCriteria.startTime).format('YYYY-MM-DD')}  至 ${moment(queryCriteria.endTime).format('YYYY-MM-DD')}   分店:${queryCriteria.branchStoreName}   票据状态: ${queryCriteria.moonStatusName}     票据类型: ${queryCriteria.moonTypeName} `]);
        worksheet.addRow(['分店', '票据类型', '折扣', '已售出', '未兑换', '已兑换', '原总价(售出)', '原总价(兑换)', '折后价']);
        worksheet.addRows(dataTable);
        worksheet.addRow(['合计', '', '', '', '', '', ""]);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);
        titlerow.getCell(1).value = "票据报表"; // A1 的值设置为"票据报表"

        // 设置标题行的行高
        titlerow.height = 40;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 30;
        const totalrow = worksheet.getRow(rows.length + 4);
        totalrow.getCell('D').value = tatalSum;   //  将值设置为总售出数量  totalSolded
        totalrow.getCell('E').value = totalSolded;  // 将值设置为总兑换数量 totalChanged
        totalrow.getCell('F').value = totalChanged.toFixed(2);  // 将值设置为原总价(售出） toTalOriginAmount
        totalrow.getCell('G').value = toTalOriginAmount.toFixed(2);  // 将值设置为原总价(兑换) toTalOriginExAmount

        totalrow.getCell('H').value = toTalOriginExAmount.toFixed(2);  // 将值设置为总折后价 totalAmount
        totalrow.getCell('I').value = totalAmount.toFixed(2);  // 将值设置为总折后价


        // 设置字体
        worksheet.getCell('A1').font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };

        let sumEnd = rows.length + 4
        //  // 合并单元格
        for (var i = 1; i <= sumEnd; i++) {
            // if (i === 1) {
            //     worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } };
            // }
            // else {

            worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('B' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('C' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('D' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('E' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('F' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('G' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('H' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('I' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('J' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            // }

            //  居中对齐并自动换行
            worksheet.getCell('A' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('B' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('C' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('D' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('E' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('F' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('G' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('H' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('I' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };



        }

        // 合并单元格
        worksheet.mergeCells('A1:I1');
        worksheet.mergeCells('A2:I2');
        worksheet.mergeCells('A' + sumEnd + ':C' + sumEnd + '');

        // 居中对齐并自动换行
        worksheet.getCell('A1').alignment = { vertical: 'bottom', horizontal: 'center', wrapText: true };
        worksheet.getCell('A2').alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
        //  设置页脚(默认居中)
        worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '票据报表.xlsx');
        })

    }

    //仓库收货统计报表
    if (apiId === "enPurStatistics") {
        console.log("该内容是" + apiId);
        console.log(rows);


        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('收货统计报表', {
            pageSetup: { paperSize: 9, orientation: 'landscape' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度
        worksheet.columns = [
            { header: '', width: 10 },
            { header: '', width: 20 },
            { header: '', width: 15 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 15 },

        ];
        // 数据
        let data = rows;


        let dataTable: any = []
        data.map((item: any) => {
            dataTable.push([
                item.selfId, item.productName, item.classificationWarehouseName, item.productUnitName, item.bNum, item.univalence, item.amount,
            ])


        })


        // 将数据插入
        worksheet.addRow([`时间: ${queryCriteria.date} ${queryCriteria.entrepotName ? `仓库：${queryCriteria.entrepotName}` : ""} ${queryCriteria.deptName ? `部门:${queryCriteria.deptName}` : ""} 分类:${queryCriteria.classificationWarehouses} 品号: ${queryCriteria.selfs} 采购商: ${queryCriteria.buyerName} `]);
        worksheet.addRow(['品号', '品名', "分类", '单位', '数量', '均价', '金额']);
        worksheet.addRows(dataTable);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);
        titlerow.getCell(1).value = "收货统计表"; // A1 的值设置为"收货统计表"

        // 设置标题行的行高
        titlerow.height = 40;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 25;
        // const totalrow = worksheet.getRow(rows.length + 4);
        // totalrow.getCell('D').value = totalSolded;   //  将值设置为总售出数量
        // totalrow.getCell('E').value = totalChanged;  // 将值设置为总兑换数量
        // totalrow.getCell('F').value = toTalOriginAmount.toFixed(2);  // 将值设置为原总价(售出）
        // totalrow.getCell('G').value = toTalOriginExAmount.toFixed(2);  // 将值设置为原总价(兑换)

        // totalrow.getCell('H').value = totalAmount.toFixed(2);  // 将值设置为总折后价

        // 设置字体
        worksheet.getCell('A1').font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };

        let sumEnd = rows.length + 3;
        //  // 合并单元格
        for (var i = 1; i <= sumEnd; i++) {
            // if (i === 1) {
            //     worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } };
            // }
            // else {

            worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('B' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('C' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('D' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('E' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('F' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('G' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('H' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('I' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('J' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            // }

            //  居中对齐并自动换行
            worksheet.getCell('A' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('B' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('C' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('D' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('E' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('F' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('G' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            // worksheet.getCell('H' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };


        }

        // 合并单元格
        worksheet.mergeCells('A1:G1');
        worksheet.mergeCells('A2:G2');

        // 居中对齐并自动换行
        worksheet.getCell('A1').alignment = { vertical: 'bottom', horizontal: 'center', wrapText: true };
        worksheet.getCell('A2').alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
        //  设置页脚(默认居中)
        worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '收货统计表.xlsx');
        })

    }

    //仓库调拨统计报表
    if (apiId === "enTrStatistics") {
        console.log("该内容是" + apiId);
        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('调拨统计报表', {
            pageSetup: { paperSize: 9, orientation: 'landscape' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度
        worksheet.columns = [
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 25 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 20 },

        ];
        // 数据
        let data = rows;


        let dataTable: any = []
        data.map((item: any) => {
            dataTable.push([
                item.selfId, item.productName, item.classificationWarehouseName, item.productUnitName, item.bNum, item.univalence, item.amount,
            ])


        })

        // 将数据插入
        worksheet.addRow([`时间: ${queryCriteria.date}  部门:${queryCriteria.deptName} 产品: ${queryCriteria.selfs} 分类:${queryCriteria.classificationWarehouses} 部门模式: ${queryCriteria.deptModel} `]);
        worksheet.addRow(['品号', '品名', "分类", '单位', '数量', '均价', '金额']);
        worksheet.addRows(dataTable);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);
        titlerow.getCell(1).value = `${queryCriteria.isBigOrder ? "总仓-" : ""}调拨统计表`; // A1 的值设置为"收货统计表"

        // 设置标题行的行高
        titlerow.height = 40;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 40;
        // const totalrow = worksheet.getRow(rows.length + 4);
        // totalrow.getCell('D').value = totalSolded;   //  将值设置为总售出数量
        // totalrow.getCell('E').value = totalChanged;  // 将值设置为总兑换数量
        // totalrow.getCell('F').value = toTalOriginAmount.toFixed(2);  // 将值设置为原总价(售出）
        // totalrow.getCell('G').value = toTalOriginExAmount.toFixed(2);  // 将值设置为原总价(兑换)

        // totalrow.getCell('H').value = totalAmount.toFixed(2);  // 将值设置为总折后价

        // 设置字体
        worksheet.getCell('A1').font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };

        let sumEnd = rows.length + 3;
        //  // 合并单元格
        for (var i = 1; i <= sumEnd; i++) {
            // if (i === 1) {
            //     worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } };
            // }
            // else {

            worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('B' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('C' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('D' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('E' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('F' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('G' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('H' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('I' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('J' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            // }

            //  居中对齐并自动换行
            worksheet.getCell('A' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('B' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('C' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('D' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('E' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('F' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('G' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            // worksheet.getCell('H' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };


        }

        // 合并单元格
        worksheet.mergeCells('A1:G1');
        worksheet.mergeCells('A2:G2');

        // 居中对齐并自动换行
        worksheet.getCell('A1').alignment = { vertical: 'bottom', horizontal: 'center', wrapText: true };
        worksheet.getCell('A2').alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
        //  设置页脚(默认居中)
        worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '调拨统计表.xlsx');
        })

    }

    // productQuery
    //商品查询
    if (apiId === "productQuery") {
        console.log("该内容是" + apiId);
        console.log(rows);


        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('商品查询', {
            pageSetup: { paperSize: 9, orientation: 'landscape' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度
        worksheet.columns = [
            { header: '', width: 15 },
            { header: '', width: 15 },
            { header: '', width: 15 },
            { header: '', width: 25 },
            { header: '', width: 15 },
        ];
        // 数据
        let data = rows;


        let dataTable: any = []
        data.map((item: any) => {
            dataTable.push([
                item.areaName, item.classificationWarehouseName, item.selfId, item.productName, item.productUnitName,
            ])


        })

        // 将数据插入
        worksheet.addRow([`区域: ${queryCriteria.areaName}  分类:${queryCriteria.classificationWarehouses}`]);
        worksheet.addRow(['区域', '分类', "品号", "品名", "单位"]);
        worksheet.addRows(dataTable);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);
        titlerow.getCell(1).value = "商品查询"; // A1 的值设置为"商品查询"

        // 设置标题行的行高
        titlerow.height = 40;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 40;
        // const totalrow = worksheet.getRow(rows.length + 4);
        // totalrow.getCell('D').value = totalSolded;   //  将值设置为总售出数量
        // totalrow.getCell('E').value = totalChanged;  // 将值设置为总兑换数量
        // totalrow.getCell('F').value = toTalOriginAmount.toFixed(2);  // 将值设置为原总价(售出）
        // totalrow.getCell('G').value = toTalOriginExAmount.toFixed(2);  // 将值设置为原总价(兑换)

        // totalrow.getCell('H').value = totalAmount.toFixed(2);  // 将值设置为总折后价

        // 设置字体
        worksheet.getCell('A1').font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };

        let sumEnd = rows.length + 4
        //  // 合并单元格
        for (var i = 1; i <= sumEnd; i++) {
            // if (i === 1) {
            //     worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } };
            // }
            // else {

            worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('B' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('C' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('D' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('E' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('F' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('G' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('H' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('I' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('J' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            // }

            //  居中对齐并自动换行
            worksheet.getCell('A' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('B' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('C' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('D' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('E' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            // worksheet.getCell('F' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            // worksheet.getCell('G' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            // worksheet.getCell('H' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };


        }

        // 合并单元格
        worksheet.mergeCells('A1:E1');
        worksheet.mergeCells('A2:E2');

        // 居中对齐并自动换行
        worksheet.getCell('A1').alignment = { vertical: 'bottom', horizontal: 'center', wrapText: true };
        worksheet.getCell('A2').alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
        //  设置页脚(默认居中)
        worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '商品查询.xlsx');
        })

    }


    //成本收货统计报表
    if (apiId === "costPurStatistics") {
        console.log("该内容是" + apiId);
        console.log(rows);


        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('成本收货统计报表', {
            pageSetup: { paperSize: 9, orientation: 'landscape' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度
        worksheet.columns = [
            { header: '', width: 15 },
            { header: '', width: 15 },
            { header: '', width: 6 },
            { header: '', width: 15 },
            { header: '', width: 6 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 6 },
            { header: '', width: 6 },

        ];
        // 数据
        let data = rows;


        let dataTable: any = []
        data.map((item: any) => {
            dataTable.push([
                item.buyerName, item.classificationWarehouseName, item.selfId, item.productName, item.productUnitName, item.univalence, item.cost, item.count, item.bNum, item.amount,
            ])


        })

        // 将数据插入
        worksheet.addRow([`时间: ${queryCriteria.date}  部门:${queryCriteria.deptName} 分类:${queryCriteria.classificationWarehouses} 品号: ${queryCriteria.selfs} 采购商: ${queryCriteria.buyerName} `]);
        worksheet.addRow(['采购商', '分类', "品号", '品名', '单位', '平均单价', '平均成本', "购买次数", "数量", "金额"]);
        worksheet.addRows(dataTable);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);
        titlerow.getCell(1).value = "成本收货统计报表"; // A1 的值设置为"收货统计表"

        // 设置标题行的行高
        titlerow.height = 40;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 40;
        // const totalrow = worksheet.getRow(rows.length + 4);
        // totalrow.getCell('D').value = totalSolded;   //  将值设置为总售出数量
        // totalrow.getCell('E').value = totalChanged;  // 将值设置为总兑换数量
        // totalrow.getCell('F').value = toTalOriginAmount.toFixed(2);  // 将值设置为原总价(售出）
        // totalrow.getCell('G').value = toTalOriginExAmount.toFixed(2);  // 将值设置为原总价(兑换)

        // totalrow.getCell('H').value = totalAmount.toFixed(2);  // 将值设置为总折后价

        // 设置字体
        worksheet.getCell('A1').font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };

        let sumEnd = rows.length + 3
        //  // 合并单元格
        for (var i = 1; i <= sumEnd; i++) {
            // if (i === 1) {
            //     worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } };
            // }
            // else {

            worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('B' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('C' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('D' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('E' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('F' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('G' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('H' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('I' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('J' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            // }

            //  居中对齐并自动换行
            worksheet.getCell('A' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('B' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('C' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('D' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('E' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('F' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('G' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('H' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('I' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('J' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };

            // worksheet.getCell('H' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };


        }

        // 合并单元格
        worksheet.mergeCells('A1:J1');
        worksheet.mergeCells('A2:J2');

        // 居中对齐并自动换行
        worksheet.getCell('A1').alignment = { vertical: 'bottom', horizontal: 'center', wrapText: true };
        worksheet.getCell('A2').alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
        //  设置页脚(默认居中)
        worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '成本收货统计报表.xlsx');
        })

    }

    //成本调拨统计报表
    if (apiId === "costTrStatistics") {
        console.log("该内容是" + apiId);
        console.log(rows);


        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('调拨统计报表', {
            pageSetup: { paperSize: 9, orientation: 'landscape' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度
        worksheet.columns = [
            { header: '', width: 10 },
            { header: '', width: 15 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },

        ];
        // 数据
        let data = rows;


        let dataTable: any = []
        data.map((item: any) => {
            dataTable.push([
                item.selfId, item.productName, item.productUnitName, item.bNum, item.univalence, item.amount,
            ])


        })

        // 将数据插入
        worksheet.addRow([`时间: ${queryCriteria.date}  部门:${queryCriteria.deptName} 产品: ${queryCriteria.selfs}  部门模式: ${queryCriteria.deptModel} `]);
        worksheet.addRow(['品号', '品名', '单位', '数量', '均价', '金额']);
        worksheet.addRows(dataTable);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);
        titlerow.getCell(1).value = "调拨统计表"; // A1 的值设置为"收货统计表"

        // 设置标题行的行高
        titlerow.height = 40;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 40;
        // const totalrow = worksheet.getRow(rows.length + 4);
        // totalrow.getCell('D').value = totalSolded;   //  将值设置为总售出数量
        // totalrow.getCell('E').value = totalChanged;  // 将值设置为总兑换数量
        // totalrow.getCell('F').value = toTalOriginAmount.toFixed(2);  // 将值设置为原总价(售出）
        // totalrow.getCell('G').value = toTalOriginExAmount.toFixed(2);  // 将值设置为原总价(兑换)

        // totalrow.getCell('H').value = totalAmount.toFixed(2);  // 将值设置为总折后价

        // 设置字体
        worksheet.getCell('A1').font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };

        let sumEnd = rows.length + 3;
        //  // 合并单元格
        for (var i = 1; i <= sumEnd; i++) {
            // if (i === 1) {
            //     worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } };
            // }
            // else {

            worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('B' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('C' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('D' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('E' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('F' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('G' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('H' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('I' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('J' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            // }

            //  居中对齐并自动换行
            worksheet.getCell('A' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('B' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('C' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('D' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('E' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('F' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            // worksheet.getCell('G' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            // worksheet.getCell('H' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };


        }

        // 合并单元格
        worksheet.mergeCells('A1:F1');
        worksheet.mergeCells('A2:F2');

        // 居中对齐并自动换行
        worksheet.getCell('A1').alignment = { vertical: 'bottom', horizontal: 'center', wrapText: true };
        worksheet.getCell('A2').alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
        //  设置页脚(默认居中)
        worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '调拨统计表.xlsx');
        })

    }

    //成本收货对比表
    if (apiId === "costPurContrast") {
        console.log("该内容是" + apiId);
        console.log(rows);


        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('成本收货对比表', {
            pageSetup: { paperSize: 9, orientation: 'landscape' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度
        worksheet.columns = [
            { header: '', width: 6 },
            { header: '', width: 10 },
            { header: '', width: 6 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },
            { header: '', width: 10 },

        ];
        // 数据
        let data = rows;


        let dataTable: any = []
        data.map((item: any) => {
            dataTable.push([
                item.selfId, item.productName, item.productUnitName, item.lastBNum, item.lastUnivalence, item.lastAmount,
                item.nowBNum, item.nowUnivalence, item.nowAmount, item.bNumDifference, item.univalenceDifference, item.amountDifference,
            ])


        })

        // 将数据插入
        worksheet.addRow([`部门:${queryCriteria.deptName} 分类:${queryCriteria.classificationWarehouses} 品号: ${queryCriteria.selfs} 采购商: ${queryCriteria.buyerName} 上次日期: ${queryCriteria.lastTime} 本次日期: ${queryCriteria.nowTime} `]);
        worksheet.addRow(['品号', '品名', "单位", '上次数量', '上次均价', '上次金额', '本次数量', "本次均价", "本次金额", "数量差异", "单价差异", "金额差异"]);
        worksheet.addRows(dataTable);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);
        titlerow.getCell(1).value = "成本收货对比表"; // A1 的值设置为"成本收货对比表"

        // 设置标题行的行高
        titlerow.height = 40;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 40;
        // const totalrow = worksheet.getRow(rows.length + 4);
        // totalrow.getCell('D').value = totalSolded;   //  将值设置为总售出数量
        // totalrow.getCell('E').value = totalChanged;  // 将值设置为总兑换数量
        // totalrow.getCell('F').value = toTalOriginAmount.toFixed(2);  // 将值设置为原总价(售出）
        // totalrow.getCell('G').value = toTalOriginExAmount.toFixed(2);  // 将值设置为原总价(兑换)

        // totalrow.getCell('H').value = totalAmount.toFixed(2);  // 将值设置为总折后价

        // 设置字体
        worksheet.getCell('A1').font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };

        let sumEnd = rows.length + 4
        //  // 合并单元格
        for (var i = 1; i <= sumEnd; i++) {

            // if (i === 1) {
            //     worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } };
            // }
            // else {


            worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('B' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('C' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('D' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('E' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('F' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('G' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('H' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('I' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('J' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('K' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('L' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            // }

            //  居中对齐并自动换行
            worksheet.getCell('A' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('B' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('C' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('D' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('E' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('F' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('G' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('H' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('I' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('J' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('K' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('L' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('H' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };


        }

        // 合并单元格
        worksheet.mergeCells('A1:L1');
        worksheet.mergeCells('A2:L2');

        // 居中对齐并自动换行
        worksheet.getCell('A1').alignment = { vertical: 'bottom', horizontal: 'center', wrapText: true };
        worksheet.getCell('A2').alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
        //  设置页脚(默认居中)
        worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '成本收货对比表.xlsx');
        })

    }
    /**出品部门统计 */
    if (apiId === "makeDept") {
        console.log("该内容是" + apiId);
        console.log(rows);
        let branchStoreName = localStorage.getItem("currentBranchStoreName")
        let brandName = localStorage.getItem("currentBrandName")


        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('出品部门统计', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度
        worksheet.columns = [
            { header: '', width: 8 },
            { header: '', width: 17 },
            { header: '', width: 10 },
            { header: '', width: 15 },
            { header: '', width: 15 },
            { header: '', width: 15 },

            // { header: '', width: 15 },
            // { header: '', width: 10 },
            { header: '', width: 15 },
            { header: '', width: 10 },
            { header: '', width: 15 },
            { header: '', width: 10 },



        ];
        // 数据
        let data = rows;


        let dataTable: any = []
        data.map((item: any, index: number) => {
            dataTable.push([
                index + 1,
                item.deptName,
                item.amount,
                item.advancePrice,
                item.discountPrice,
                item.reducedPrice,

                // item.foodBackPrice,
                // item.foodBackAmount,
                item.refundPrice,
                item.refundAmount,
                item.giftPrice,
                item.giftAmount,
            ])


        })
        let { date, sbName, userName, caCoMonStatusName } = queryCriteria;


        let startTime;
        let endTime;


        if (date.length > 0) {
            startTime = dayjs(date[0]).format("YYYY-MM-DD")
            endTime = dayjs(date[1]).format("YYYY-MM-DD")

        }

        // 将数据插入
        worksheet.addRow([`${date ? `日期:${startTime}至${endTime}` : ""}`]);
        worksheet.addRow([`单位:${brandName}${branchStoreName}`, '', '', `市别:${sbName}`, '', '']);
        worksheet.addRow([`菜状态:${caCoMonStatusName}`]);


        worksheet.addRow(['序号', '部门', '数量', "金额(折前)", '折扣', '金额(折后)', '金额(退货)', '数量(退货)', '金额(赠送)', '数量(赠送)']);
        worksheet.addRows(dataTable);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);
        titlerow.getCell(1).value = "出品部门统计"; // A1 的值设置为"出品部门统计"

        // 设置标题行的行高
        titlerow.height = 40;
        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 40;
        // const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        // searchParameterrow.height = 40;
        // const totalrow = worksheet.getRow(rows.length + 4);
        // totalrow.getCell('D').value = totalSolded;   //  将值设置为总售出数量
        // totalrow.getCell('E').value = totalChanged;  // 将值设置为总兑换数量
        // totalrow.getCell('F').value = toTalOriginAmount.toFixed(2);  // 将值设置为原总价(售出）
        // totalrow.getCell('G').value = toTalOriginExAmount.toFixed(2);  // 将值设置为原总价(兑换)

        // totalrow.getCell('H').value = totalAmount.toFixed(2);  // 将值设置为总折后价

        // 设置字体
        worksheet.getCell('A1').font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };
        // 设置字体
        worksheet.getRow(3).font = {
            name: '宋体',
            family: 4,
            size: 15,
            bold: true
        };
        worksheet.getRow(4).font = {
            name: '宋体',
            family: 4,
            size: 15,
            bold: true
        };
        let sumEnd = rows.length + 6
        //  // 合并单元格
        for (var i = 1; i <= sumEnd; i++) {

            if (i === 1) {

            } else {
                // worksheet.getRow(i).height = 30;
            }
            worksheet.getCell('A' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('B' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('C' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('D' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('E' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('F' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            worksheet.getCell('G' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            worksheet.getCell('H' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('I' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('J' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('K' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            // worksheet.getCell('L' + i + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };





            //  居中对齐并自动换行
            worksheet.getCell('A' + i + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('B' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('C' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('D' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('E' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('F' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('G' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('H' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('I' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('J' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            // worksheet.getCell('K' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };
            // worksheet.getCell('L' + i + '').alignment = { vertical: 'middle', horizontal: 'center' };




        }

        // 合并单元格
        worksheet.mergeCells('A1:J1');
        worksheet.mergeCells('A2:J2');
        worksheet.mergeCells('A3:C3');
        worksheet.mergeCells('D3:J3');
        worksheet.mergeCells('A4:J4');




        let finallyRow = worksheet.getRow(sumEnd);

        finallyRow.getCell(1).value = `制表人:${userName}`; // A1 的值设置为"收货统计表"
        finallyRow.getCell(5).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`; // A1 的值设置为"收货统计表"
        worksheet.mergeCells(`A${sumEnd}:B${sumEnd}`)
        worksheet.mergeCells(`E${sumEnd}:J${sumEnd}`)

        // 居中对齐并自动换行
        worksheet.getCell('A1').alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        worksheet.getCell('A2').alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        worksheet.getCell(`A${sumEnd}`).alignment = { vertical: "middle", horizontal: "justify", wrapText: true };
        worksheet.getCell(`A3`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        worksheet.getCell(`E3`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
        worksheet.getCell('A4').alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        //去除边框线
        worksheet.getRow(1).border = {};
        worksheet.getRow(2).border = {};
        worksheet.getRow(3).border = {};
        worksheet.getRow(4).border = {};

        worksheet.getRow(sumEnd).border = {};


        //  设置页脚(默认居中)
        // worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel

        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '出品部门统计.xlsx');
        })

    }


    /**销售明细统计 */
    if (apiId === "salesDetail") {
        console.log("该内容是" + apiId);
        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        let branchStoreName = localStorage.getItem("currentBranchStoreName")
        let brandName = localStorage.getItem("currentBrandName")
        //添加工作表
        const worksheet = workbook.addWorksheet('销售明细统计', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        let { date, shopTypeName, sbName, userName, caCoMonStatusName, columnsHead } = queryCriteria;
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };


        // 添加列标题并定义列键和宽度
        worksheet.columns = columnsHead
        worksheet.addRows(rows)



        let startTime;
        let endTime;

        if (date.length > 0) {
            startTime = dayjs(date[0]).format("YYYY-MM-DD")
            endTime = dayjs(date[1]).format("YYYY-MM-DD")

        }
        // 将数据插入
        worksheet.insertRow(1, [`分类: ${shopTypeName},菜状态:${caCoMonStatusName}`]);
        worksheet.insertRow(1, [`单位:${brandName}${branchStoreName}`, '', `x`, ``, `市别:${sbName}`, '', '']);
        worksheet.insertRow(1, [` ${date ? `日期:${startTime}至${endTime}` : ""}`]);
        worksheet.insertRow(1, [`销售明细统计`]);

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 40;

        let sumEnd = rows.length + 6;
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            })
            if (rowNumber === 1) {
                row.font = { size: 25, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 20, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            } else if (rowNumber === 3) {
                row.font = { size: 18, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }
            else if (rowNumber === 4) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 20;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }

        });
        // 合并单元格
        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(columnsHead.length + 64)}2`);
        worksheet.mergeCells('A3:D3');
        worksheet.mergeCells(`E3:${String.fromCharCode(columnsHead.length + 64)}3`);


        worksheet.mergeCells(`A4:${String.fromCharCode(columnsHead.length + 64)}4`);



        let finallyRow = worksheet.getRow(sumEnd);
        // worksheet.ge
        finallyRow.getCell(1).value = `制表人:${userName}`; // A1 的值设置为"收货统计表"
        finallyRow.getCell(5).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`; // A1 的值设置为"收货统计表"

        worksheet.mergeCells(`A${sumEnd}:D${sumEnd}`)
        worksheet.mergeCells(`E${sumEnd}:${String.fromCharCode(columnsHead.length + 64)}${sumEnd}`)


        //去除边框线
        worksheet.getRow(1).border = {};
        worksheet.getRow(2).border = {};
        worksheet.getRow(3).border = {};
        worksheet.getRow(4).border = {};


        worksheet.getRow(sumEnd).border = {};

        // 居中对齐并自动换行
        worksheet.getRow(1).alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        worksheet.getRow(2).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        // worksheet.getRow(3).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        worksheet.getRow(4).alignment = { vertical: "middle", horizontal: "center", wrapText: true };

        worksheet.getCell(`A3`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        worksheet.getCell(`E3`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };

        worksheet.getCell(`A${sumEnd}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        worksheet.getCell(`E${sumEnd}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
        //  设置页脚(默认居中)
        // worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '销售明细统计.xlsx');
        })


    }

    /**结账方式统计 */
    if (apiId === "paymentMethodCount") {
        console.log("该内容是" + apiId);
        let branchStoreName = localStorage.getItem("currentBranchStoreName")
        let brandName = localStorage.getItem("currentBrandName")
        let { date, sbName, userName, actualOrderCounts, columnsHead, orderCounts, refundOrderCounts } = queryCriteria;
        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('结账方式统计', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度
        worksheet.columns = columnsHead
        // 数据
        let data = rows;
        worksheet.addRows(data);



        let startTime;
        let endTime;

        if (date.length > 0) {
            startTime = dayjs(date[0]).format("YYYY-MM-DD")
            endTime = dayjs(date[1]).format("YYYY-MM-DD")

        }
        // 将数据插入





        // 获取一个行对象。
        // const titlerow = worksheet.getRow(1);
        // titlerow.getCell(1).value = "结账方式统计"; // A1 的值设置为"收货统计表"



        worksheet.insertRow(1, [`订单笔数:${orderCounts}`, "", `退款笔数:${refundOrderCounts}`, "", '', `成交笔数:${actualOrderCounts}`, '']);
        worksheet.insertRow(1, [`单位:${brandName}${branchStoreName}`, "", "", "", `市别:${sbName}`]);

        worksheet.insertRow(1, [`${date ? `日期:${startTime}至${endTime}` : ""}`]);
        worksheet.insertRow(1, [`结账方式统计`]);




        // 设置标题行的行高
        // titlerow.height = 40;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 40;

        //获取第四行
        const firstRow = worksheet.getRow(4);
        firstRow.height = 30;

        // 设置字体
        worksheet.getCell('A1').font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };
        // 设置字体
        worksheet.getRow(2).font = {
            name: '宋体',
            family: 4,
            size: 15,
            bold: true
        };
        // 设置字体
        worksheet.getRow(3).font = {
            name: '宋体',
            family: 4,
            size: 15,
            bold: true
        };

        // 设置字体
        worksheet.getRow(4).font = {
            name: '宋体',
            family: 4,
            size: 15,
            bold: true,

        };

        let sumEnd = rows.length + 6;
        //  // 合并单元格
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })

            if (rowNumber === 1) {
                row.font = { size: 25, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 20, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            } else if (rowNumber === 3) {
                row.font = { size: 18, name: 'Arial', bold: true };
                row.height = 20;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }
            else if (rowNumber === 4) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 20;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            }
        });

        // 合并单元格
        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(columnsHead.length + 64)}2`);


        worksheet.mergeCells('A3:D3');
        worksheet.mergeCells(`E3:${String.fromCharCode(columnsHead.length + 64)}3`);

        worksheet.mergeCells('A4:B4');
        worksheet.mergeCells('C4:E4');

        worksheet.mergeCells(`F4:${String.fromCharCode(columnsHead.length + 64)}4`);

        //去除边框线
        worksheet.getRow(1).border = {};
        worksheet.getRow(2).border = {};
        worksheet.getRow(3).border = {};
        worksheet.getRow(4).border = {};

        // worksheet.getRow(3).border = {};





        let finallyRow = worksheet.getRow(sumEnd);

        finallyRow.getCell(1).value = `制表人:${userName}`; // A1 的值设置为"收货统计表"
        finallyRow.getCell(3).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`; // A1 的值设置为"收货统计表"

        worksheet.mergeCells(`A${sumEnd}:B${sumEnd}`)
        worksheet.mergeCells(`C${sumEnd}:E${sumEnd}`)

        worksheet.getRow(sumEnd).border = {};

        // 居中对齐并自动换行
        worksheet.getRow(1).alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        worksheet.getRow(2).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        worksheet.getCell(`A${sumEnd}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        worksheet.getCell(`E${sumEnd}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
        worksheet.getCell(`A3`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        worksheet.getCell(`E3`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };



        //  设置页脚(默认居中)
        // worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });


        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '结账方式统计.xlsx');
        })


    }

    /**房台统计 */
    if (apiId === "roomPlatformStatistics") {
        console.log("该内容是" + apiId);
        console.log("rows", rows);

        let branchStoreName = localStorage.getItem("currentBranchStoreName")
        let brandName = localStorage.getItem("currentBrandName")

        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('房台统计', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度

        // 数据



        let { date, sbName, userName, roomTypeName, columnsHead } = queryCriteria;
        worksheet.columns = columnsHead

        let startTime;
        let endTime;

        if (date.length > 0) {
            startTime = dayjs(date[0]).format("YYYY-MM-DD")
            endTime = dayjs(date[1]).format("YYYY-MM-DD")

        }
        worksheet.addRows(rows);
        // 将数据插入
        worksheet.insertRow(1, [`房型:${roomTypeName ? roomTypeName : "所有"}`]);
        worksheet.insertRow(1, [`单位:${brandName}${branchStoreName}`, '', '', '', '', `市别:${sbName}`, '', '']);
        worksheet.insertRow(1, [`${date ? `日期:${startTime}至${endTime}` : ""} `]);
        worksheet.insertRow(1, ["房台统计"]);

        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);

        // 设置标题行的行高
        titlerow.height = 40;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 40;


        // 设置字体
        worksheet.getRow(1).font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };
        // 设置字体
        worksheet.getRow(3).font = {
            name: '宋体',
            family: 4,
            size: 15,
            bold: true
        };
        let sumEnd = rows.length + 6;
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 25, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 20, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            } else if (rowNumber === 3) {
                row.font = { size: 18, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }
            else if (rowNumber === 4) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 20;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }

        });

        // 合并单元格
        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(columnsHead.length + 64)}2`);
        worksheet.mergeCells(`A3:E3`);
        worksheet.mergeCells(`F3:${String.fromCharCode(columnsHead.length + 64)}3`);
        worksheet.mergeCells(`A4:${String.fromCharCode(columnsHead.length + 64)}4`);



        let finallyRow = worksheet.getRow(sumEnd);


        worksheet.mergeCells(`A${sumEnd}:F${sumEnd}`)
        worksheet.mergeCells(`G${sumEnd}:${String.fromCharCode(columnsHead.length + 64)}${sumEnd}`);

        finallyRow.getCell(1).value = `制表人:${userName}`;
        finallyRow.getCell(7).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;

        // 居中对齐并自动换行
        worksheet.getCell('A1').alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        worksheet.getCell('A2').alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        worksheet.getCell('A4').alignment = { vertical: "middle", horizontal: "center", wrapText: true };

        worksheet.getCell(`A${sumEnd}`).alignment = { vertical: "middle", horizontal: "justify", wrapText: true };
        worksheet.getCell(`A3`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        worksheet.getCell(`F3`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };




        //去除边框线
        worksheet.getRow(1).border = {};
        worksheet.getRow(2).border = {};
        worksheet.getRow(3).border = {};
        worksheet.getRow(4).border = {};

        worksheet.getRow(sumEnd).border = {};
        //  设置页脚(默认居中)
        // worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });


        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '房台统计.xlsx');
        })


    }

    /**房台统计 */
    if (apiId === "roomPlatNumber") {
        console.log("该内容是" + apiId);
        console.log("rows", rows);
        console.log("queryCriteria", queryCriteria);

        let branchStoreName = localStorage.getItem("currentBranchStoreName")
        let brandName = localStorage.getItem("currentBrandName")

        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('房台人数', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度

        let { date, columnsHead } = queryCriteria;
        worksheet.columns = columnsHead

        let startTime;
        let endTime;

        if (date.length > 0) {
            startTime = dayjs(date[0]).format("YYYY-MM-DD")
            endTime = dayjs(date[1]).format("YYYY-MM-DD")

        }
        worksheet.addRows(rows);
        // 将数据插入
        worksheet.insertRow(1, [`单位:${brandName}${branchStoreName}`]);
        worksheet.insertRow(1, [`${date ? `日期:${startTime}至${endTime}` : ""} `]);
        worksheet.insertRow(1, ["房台人数统计"]);

        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);

        // 设置标题行的行高
        titlerow.height = 20;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 20;


        // 设置字体
        worksheet.getRow(1).font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };
        // 设置字体
        worksheet.getRow(3).font = {
            name: '宋体',
            family: 4,
            size: 15,
            bold: true
        };
        let sumEnd = rows.length + 6;
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 15, name: 'Arial', bold: true };
                row.height = 20;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 15, name: 'Arial', bold: true };
                row.height = 20;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            } else if (rowNumber === 3) {
                row.font = { size: 13, name: 'Arial', bold: true };
                row.height = 20;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }


        });

        // 合并单元格
        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(columnsHead.length + 64)}2`);
        worksheet.mergeCells(`A3:${String.fromCharCode(columnsHead.length + 64)}3`);



        // let finallyRow = worksheet.getRow(sumEnd);


        // worksheet.mergeCells(`A${sumEnd}:F${sumEnd}`)
        // worksheet.mergeCells(`G${sumEnd}:${String.fromCharCode(columnsHead.length + 64)}${sumEnd}`);

        // finallyRow.getCell(1).value = `制表人:${userName}`;
        // finallyRow.getCell(7).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;

        // 居中对齐并自动换行
        // worksheet.getCell('A1').alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        // worksheet.getCell('A2').alignment = { vertical: "middle", horizontal: "center", wrapText: true };

        // worksheet.getCell(`A${sumEnd}`).alignment = { vertical: "middle", horizontal: "justify", wrapText: true };
        // worksheet.getCell(`A3`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };




        //去除边框线
        worksheet.getRow(1).border = {};
        worksheet.getRow(2).border = {};
        worksheet.getRow(3).border = {};

        worksheet.getRow(sumEnd).border = {};
        //  设置页脚(默认居中)
        // worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });


        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '房台统计.xlsx');
        })


    }

    /**楼层统计 */
    if (apiId === "brandStoreFloorStatistics") {
        console.log("该内容是" + apiId);
        console.log("rows", rows);

        let branchStoreName = localStorage.getItem("currentBranchStoreName")
        let brandName = localStorage.getItem("currentBrandName")

        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('楼层统计', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度

        // 数据



        let { date, sbName, userName, columnsHead } = queryCriteria;
        worksheet.columns = columnsHead

        let startTime;
        let endTime;

        if (date.length > 0) {
            startTime = dayjs(date[0]).format("YYYY-MM-DD")
            endTime = dayjs(date[1]).format("YYYY-MM-DD")

        }
        worksheet.addRows(rows);
        // 将数据插入
        worksheet.insertRow(1, [`单位:${brandName}${branchStoreName}`, '', '', `市别:${sbName}`, '', '']);
        worksheet.insertRow(1, [`${date ? `日期:${startTime}至${endTime}` : ""} `]);
        worksheet.insertRow(1, ["楼层统计"]);

        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);

        // 设置标题行的行高
        titlerow.height = 40;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 40;


        // 设置字体
        worksheet.getRow(1).font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };
        // 设置字体
        worksheet.getRow(3).font = {
            name: '宋体',
            family: 4,
            size: 15,
            bold: true
        };
        let sumEnd = rows.length + 5;
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 25, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 20, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            } else if (rowNumber === 3) {
                row.font = { size: 18, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }
        });

        // 合并单元格
        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(columnsHead.length + 64)}2`);
        worksheet.mergeCells(`A3:C3`);
        worksheet.mergeCells(`D3:${String.fromCharCode(columnsHead.length + 64)}3`);



        let finallyRow = worksheet.getRow(sumEnd);

        // worksheet.mergeCells(`A${sumEnd}:F${sumEnd}`)
        worksheet.mergeCells(`A${sumEnd}:C${sumEnd}`);
        worksheet.mergeCells(`D${sumEnd}:${String.fromCharCode(columnsHead.length + 64)}${sumEnd}`);


        finallyRow.getCell(1).value = `制表人:${userName}`;
        finallyRow.getCell(5).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;

        // 居中对齐并自动换行
        worksheet.getCell('A1').alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        worksheet.getCell('A2').alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        worksheet.getCell('A4').alignment = { vertical: "middle", horizontal: "center", wrapText: true };

        worksheet.getCell(`A${sumEnd}`).alignment = { vertical: "middle", horizontal: "justify", wrapText: true };
        worksheet.getCell(`A3`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        worksheet.getCell(`D3`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };



        //去除边框线
        worksheet.getRow(1).border = {};
        worksheet.getRow(2).border = {};
        worksheet.getRow(3).border = {};

        worksheet.getRow(sumEnd).border = {};
        //  设置页脚(默认居中)
        // worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";
        // 下载 excel
        // workbook.xlsx.writeBuffer().then((buf) => {
        //     let blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        //     const downloadElement = document.createElement('a')
        //     let href = window.URL.createObjectURL(blob)
        //     downloadElement.href = href
        //     downloadElement.download = "申购表.xlsx"; // 文件名字
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement) // 下载完成移除元素
        //     window.URL.revokeObjectURL(href) // 释放掉blob对象
        // });


        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '楼层统计.xlsx');
        })

    }

    /**加工厂统计 */
    if (apiId === "processingStatistics") {
        console.log("该内容是" + apiId);
        console.log(queryCriteria);

        const { time, columnsHead } = queryCriteria
        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('加工厂统计', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });


        worksheet.columns = columnsHead;


        worksheet.addRows(rows)
        worksheet.insertRow(1, [`日期:${time}`]);
        worksheet.insertRow(1, ["切配中心下单表"]);
        worksheet.eachRow(function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {


                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 14, name: 'Arial', };
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }

        });


        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(columnsHead.length + 64)}2`);


        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '切配中心.xlsx');
        })

    }

    /**加工厂申购统计 */
    if (apiId === "processingRequisition") {
        console.log("该内容是" + apiId);
        console.log(queryCriteria);
        console.log("rows", rows);

        const { time, columnsHead } = queryCriteria
        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('切配中心申购单', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });


        worksheet.columns = columnsHead;


        worksheet.addRows(rows)
        worksheet.insertRow(1, [`日期:${time}`]);
        worksheet.insertRow(1, ["切配中心申购单"]);
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {


                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 14, name: 'Arial', };
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }

        });


        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(columnsHead.length + 64)}2`);


        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '切配中心申购单.xlsx');
        })

    }
    //菜品智库的所有菜式
    if (apiId === "menuWarehouse") {
        // 创建工作薄
        const workbook = new ExcelJS.Workbook();

        // 添加工作表并进行页面设置
        // 使用 A4 横向的页面设置创建新工作表
        const worksheet = workbook.addWorksheet(" 菜品智库所有菜式", {
            pageSetup: { paperSize: 9, orientation: 'landscape' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });

        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.4,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };

        // 添加列标题并定义列键和宽度
        worksheet.columns = [
            { header: '序号', width: 5 },
            { header: '品牌', width: 13 },
            { header: '大分类', width: 10 },
            { header: '小分类', width: 10 },
            { header: '菜名', width: 25 },
            { header: '做法', width: 10 },
            { header: '创于', width: 6 },
            { header: '年份', width: 6 },
            { header: '版本号', width: 6 },
            { header: '简介', width: 25 },
            { header: '创作理念', width: 25 },
        ];

        // 数据
        let data = rows;
        //console.log("获取表格内容", data)

        let dataTable: any = [];

        let introductionCuror: any = [];   //  用来记录有介绍或创作理念的位置
        let introductionLength: any = [];     //  用来记录介绍或创作理念的内容长度,方便根据长度来设置行高

        data.map((item: any, index: any) => {
            dataTable.push([
                index + 1, item.brand.brandName, item.menuWarehouseType.menuWarehouseCategory.menuWarehouseCategoryName, item.menuWarehouseType.menuWarehouseTypeName, item.foodName, item.cookMethod.cookMethodName, item.area?.areaName, item.created, item.version, item.introduction, item.creativeConcept
            ])
            if (item.introduction || item.creativeConcept) {
                introductionCuror.push(index + 2);

                let introduction = item.introduction ? item.introduction.length : 0;  //防止数据为空时，没有长度会报错，所以判断空的时候长度为0
                let creativeConcept = item.creativeConcept ? item.creativeConcept.length : 0;

                introductionLength.push(introduction > creativeConcept ? introduction : creativeConcept);
            }
        })

        // 将数据插入
        worksheet.addRows(dataTable);

        // 设置第一行的行高
        worksheet.getRow(1).height = 25;

        // 设置第一行居中对齐
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('B1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('C1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('D1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('E1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('F1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('G1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('H1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('I1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('J1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('K1').alignment = { vertical: 'middle', horizontal: 'center' };

        // 设置第一行边框
        worksheet.getCell('A1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('B1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('C1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('D1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('E1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('F1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('G1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('H1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('I1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('J1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell('K1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

        //  设置边框、对齐、合并、行高等操作
        for (var curor = 2; curor < data.length + 2; curor++) {
            //  设置行高
            // console.log(curor);

            if (introductionCuror.indexOf(curor) !== -1) {
                //如果该行数据有介绍或有创作理念，就把行高设高一点
                if (introductionLength[introductionCuror.indexOf(curor)] <= 25) {
                    worksheet.getRow(curor).height = 20;
                }
                else {
                    worksheet.getRow(curor).height = introductionLength[introductionCuror.indexOf(curor)] / 25 * 40;
                }
            }
            else {
                worksheet.getRow(curor).height = 20;
            }
        }

        for (var k = 2, len = data.length + 2; k < len; k++) {
            //  设置对齐方式和是否自动换行
            worksheet.getCell('A' + k + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('B' + k + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('C' + k + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('D' + k + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('E' + k + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('F' + k + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('G' + k + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('H' + k + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('I' + k + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('J' + k + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('K' + k + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

            // 设置边框
            worksheet.getCell('A' + k + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
            worksheet.getCell('B' + k + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
            worksheet.getCell('C' + k + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
            worksheet.getCell('D' + k + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
            worksheet.getCell('E' + k + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
            worksheet.getCell('F' + k + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
            worksheet.getCell('G' + k + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
            worksheet.getCell('H' + k + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
            worksheet.getCell('I' + k + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
            worksheet.getCell('J' + k + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
            worksheet.getCell('K' + k + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
        }

        //  设置页脚(默认居中)
        worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";

        // 将工作薄导出为excel文件
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '菜品智库所有菜式.xlsx');
        })
    }

    //菜谱头的所有菜式
    if (apiId === "menuHead") {
        // console.log("该内容是" + apiId);
        // console.log(rows);
        if (queryCriteria.downloadIsCb) {
            /* 成本版*/

            // 创建工作薄
            const workbook = new ExcelJS.Workbook();

            // 添加工作表并进行页面设置
            // 使用 A4 横向的页面设置创建新工作表
            const worksheet = workbook.addWorksheet(queryCriteria.branchStoreName + " - " + queryCriteria.menuHeadName, {
                pageSetup: { paperSize: 9, orientation: 'landscape' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
            });

            // 调整页面设置配置
            worksheet.pageSetup.margins = {
                left: 0.2, right: 0.2,
                top: 0.5, bottom: 0.5,
                header: 0.3, footer: 0.3
            };

            // 添加列标题并定义列键和宽度
            worksheet.columns = [
                { header: '序号', width: 5 },
                { header: '分类', width: 15 },
                { header: '菜名', width: 40 },
                { header: '单位', width: 10 },
                { header: '规格', width: 15 },
                { header: '售价', width: 10 },
                { header: '份量', width: 70 },
                { header: '成本', width: 10 },
                { header: '毛利率', width: 10 },
            ];

            // 数据
            let data = rows;
            //console.log("获取表格内容", data)

            let productbegin: any = [];   //  用来记录产品开始循环的位置
            let productend: any = [];     //  用来记录产品结束循环的位置

            let j = 2;

            let dataTable: any = [];
            data.map((item: any, index: any) => {
                let i = 1;  // 由于productOrderDetails数据里面，最后的2条是没用的，为了防止通过map循环全部读取，这里设置一个i用了记录当前数据的位置
                let productCuror = 1;  // 记录商品的指针，用于设置名称等内容

                productbegin.push(j);   // 将每一个数据开始的位置记录，方便用了合并单元格

                item.menuSpecs.map((productitem: any) => {
                    let costPrices;
                    let grossProfitRatio;
                    let newData = productitem.branchStoreMenuWarehouseSpec.menuWarehouseIngredients[0]?.newData;

                    if (productitem.branchStoreMenuWarehouseSpec.menuWarehouseIngredients.length > 0) {
                        if (newData) {
                            costPrices = newData.costPrices;
                            grossProfitRatio = newData.grossProfitRatio + "%";

                        }
                        else {
                            costPrices = productitem.branchStoreMenuWarehouseSpec.menuWarehouseIngredients[0].costPrices;
                            grossProfitRatio = productitem.branchStoreMenuWarehouseSpec.menuWarehouseIngredients[0].grossProfitRatio + "%";
                        }
                    }
                    else {
                        costPrices = '';
                        grossProfitRatio = '';
                    }

                    if (i <= item.menuSpecs.length) {
                        // 在该订单内商品循环,并将内容push入数组
                        if (item.menuSpecs.length === 1) {
                            //productbegin.push(j);   // 将每一个数据开始的位置记录，方便用了合并单元格
                            dataTable.push([
                                index + 1, item.shopType.shopTypeName, item.foodName, item.isPrintSpec ? item.branchStoreMenuWarehouse?.productUnit ? item.branchStoreMenuWarehouse?.productUnit?.productUnitName : "" : "", productitem.menuSpecName, productitem.price, productitem.branchStoreMenuWarehouseSpec.ingredientDetail, costPrices, grossProfitRatio
                            ])
                        }
                        else {
                            if (productCuror === 1) {
                                dataTable.push([
                                    index + 1, item.shopType.shopTypeName, item.foodName, item.isPrintSpec ? item.branchStoreMenuWarehouse?.productUnit ? item.branchStoreMenuWarehouse?.productUnit?.productUnitName : "" : "", productitem.menuSpecName, productitem.price, productitem.branchStoreMenuWarehouseSpec.ingredientDetail, costPrices, grossProfitRatio
                                ])

                                productCuror = productCuror + 1;
                            }
                            else {
                                dataTable.push([
                                    "", "", "", "", productitem.menuSpecName, productitem.price, productitem.branchStoreMenuWarehouseSpec.ingredientDetail, costPrices, grossProfitRatio
                                ])
                                productCuror = productCuror + 1;
                            }
                        }

                        // 判断是否已经将该订单内商品循环完了，如果循环完了就显示公共信息内容(如下单时间、备注)
                        if (i === item.menuSpecs.length) {
                            //console.log( item.id +'的到最后了');
                            if (item.menuSpecs.length === 1) {
                                productend.push(j);
                                j = j + 1;
                            }
                            else {
                                productend.push(j + item.menuSpecs.length - 1);   // 将每一个数据结束的位置记录，方便用了合并单元格
                                j = j + item.menuSpecs.length;
                            }
                        }
                        i = i + 1;
                    }
                })
            })

            // 将数据插入
            worksheet.addRows(dataTable);

            // 设置第一行的行高
            worksheet.getRow(1).height = 25;

            // 设置第一行居中对齐
            worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('B1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('C1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('D1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('E1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('F1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('G1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('H1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('I1').alignment = { vertical: 'middle', horizontal: 'center' };

            // 设置第一行边框
            worksheet.getCell('A1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('B1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('C1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('D1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('E1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('F1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('G1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('H1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('I1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            //  设置边框、对齐、合并、行高等操作
            for (var curor = 2; curor <= productend[productend.length - 1]; curor++) {
                //  设置行高
                // console.log(curor);
                worksheet.getRow(curor).height = 20;
            }

            for (var k = 0, len = productbegin.length; k < len; k++) {
                if (productend[k] - productbegin[k] >= 0) {

                    for (var productroll = productbegin[k]; productroll <= productend[k]; productroll++) {
                        //  设置对齐方式和是否自动换行
                        worksheet.getCell('A' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        worksheet.getCell('B' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        worksheet.getCell('C' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        worksheet.getCell('D' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        worksheet.getCell('E' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        worksheet.getCell('F' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        worksheet.getCell('G' + productroll + '').alignment = { vertical: 'middle', horizontal: 'left', wrapText: false };
                        worksheet.getCell('H' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        worksheet.getCell('I' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

                        // 设置边框
                        worksheet.getCell('A' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('B' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('C' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('D' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('E' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('F' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('G' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('H' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('I' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                    }
                }
            }

            //  将除了(微信用户、品名、地址)的单元格都设置为居中
            for (var product = 0; product < productbegin.length; product++) {

                if (productend[product] - productbegin[product] > 0) {
                    //  合并单元格
                    worksheet.mergeCells('A' + productbegin[product] + ':A' + productend[product] + '');
                    worksheet.mergeCells('B' + productbegin[product] + ':B' + productend[product] + '');
                    worksheet.mergeCells('C' + productbegin[product] + ':C' + productend[product] + '');
                    worksheet.mergeCells('D' + productbegin[product] + ':D' + productend[product] + '');
                }
            }

            //  设置页脚(默认居中)
            worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";

            // 将工作薄导出为excel文件
            workbook.xlsx.writeBuffer().then((item) => {
                const blob = new Blob([item], { type: "EXCEL_TYPE" });
                FileSaver.saveAs(blob, queryCriteria.branchStoreName + " - " + queryCriteria.menuHeadName + moment().format('YYYY-MM-DD') + '.xlsx');
            })
        }
        else {
            /* 收银版*/

            // 创建工作薄
            const workbook = new ExcelJS.Workbook();

            // 添加工作表并进行页面设置
            // 使用 A4 横向的页面设置创建新工作表
            const worksheet = workbook.addWorksheet(queryCriteria.branchStoreName + " - " + queryCriteria.menuHeadName, {
                pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
            });

            // 调整页面设置配置
            worksheet.pageSetup.margins = {
                left: 0.4, right: 0.4,
                top: 0.5, bottom: 0.5,
                header: 0.3, footer: 0.3
            };

            // 添加列标题并定义列键和宽度
            worksheet.columns = [
                { header: '序号', width: 5 },
                { header: '分类', width: 15 },
                { header: '菜名', width: 40 },
                { header: '单位', width: 10 },
                { header: '规格', width: 15 },
                { header: '售价', width: 10 },
            ];

            // 数据
            let data = rows
            //console.log("获取表格内容", data)

            let productbegin: any = []     //  用来记录产品开始循环的位置
            let productend: any = []     //  用来记录产品结束循环的位置

            let j = 2

            let dataTable: any = []
            data.map((item: any, index: any) => {

                let i = 1;  // 由于productOrderDetails数据里面，最后的2条是没用的，为了防止通过map循环全部读取，这里设置一个i用了记录当前数据的位置
                let productCuror = 1  // 记录商品的指针，用于设置名称等内容

                productbegin.push(j);   // 将每一个数据开始的位置记录，方便用了合并单元格

                item.menuSpecs.map((productitem: any) => {

                    if (i <= item.menuSpecs.length) {
                        // 在该订单内商品循环,并将内容push入数组
                        if (item.menuSpecs.length === 1) {
                            //productbegin.push(j);   // 将每一个数据开始的位置记录，方便用了合并单元格
                            dataTable.push([
                                index + 1, item.shopType.shopTypeName, item.foodName, item.isPrintSpec ? item.branchStoreMenuWarehouse?.productUnit ? item.branchStoreMenuWarehouse?.productUnit?.productUnitName : "" : "", productitem.menuSpecName, productitem.price
                            ])
                        }
                        else {
                            if (productCuror === 1) {
                                dataTable.push([
                                    index + 1, item.shopType.shopTypeName, item.foodName, item.isPrintSpec ? item.branchStoreMenuWarehouse?.productUnit ? item.branchStoreMenuWarehouse?.productUnit?.productUnitName : "" : "", productitem.menuSpecName, productitem.price
                                ])

                                productCuror = productCuror + 1;
                            }
                            else {
                                dataTable.push([
                                    "", "", "", "", productitem.menuSpecName, productitem.price
                                ])
                                productCuror = productCuror + 1;
                            }
                        }

                        // 判断是否已经将该订单内商品循环完了，如果循环完了就显示公共信息内容(如下单时间、备注)
                        if (i === item.menuSpecs.length) {
                            //console.log( item.id +'的到最后了');
                            if (item.menuSpecs.length === 1) {
                                productend.push(j);
                                j = j + 1;
                            }
                            else {
                                productend.push(j + item.menuSpecs.length - 1);   // 将每一个数据结束的位置记录，方便用了合并单元格
                                j = j + item.menuSpecs.length;
                            }
                        }
                        i = i + 1;
                    }
                })
            })

            // 将数据插入
            worksheet.addRows(dataTable);

            // 设置第一行的行高
            worksheet.getRow(1).height = 25;

            // 设置第一行居中对齐
            worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('B1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('C1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('D1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('E1').alignment = { vertical: 'middle', horizontal: 'center' };
            worksheet.getCell('F1').alignment = { vertical: 'middle', horizontal: 'center' };

            // 设置第一行边框
            worksheet.getCell('A1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('B1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('C1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('D1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('E1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell('F1').border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

            //  设置边框、对齐、合并、行高等操作
            for (var curor = 2; curor <= productend[productend.length - 1]; curor++) {
                //  设置行高
                // console.log(curor);
                worksheet.getRow(curor).height = 20;
            }

            for (var k = 0, len = productbegin.length; k < len; k++) {
                if (productend[k] - productbegin[k] >= 0) {

                    for (var productroll = productbegin[k]; productroll <= productend[k]; productroll++) {
                        //  设置对齐方式和是否自动换行
                        worksheet.getCell('A' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        worksheet.getCell('B' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        worksheet.getCell('C' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        worksheet.getCell('D' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        worksheet.getCell('E' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        worksheet.getCell('F' + productroll + '').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

                        // 设置边框
                        worksheet.getCell('A' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('B' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('C' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('D' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('E' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                        worksheet.getCell('F' + productroll + '').border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' }, bottom: { style: 'thin' } };
                    }
                }
            }

            //  将除了(微信用户、品名、地址)的单元格都设置为居中
            for (var product = 0; product < productbegin.length; product++) {

                if (productend[product] - productbegin[product] > 0) {
                    //  合并单元格
                    worksheet.mergeCells('A' + productbegin[product] + ':A' + productend[product] + '');
                    worksheet.mergeCells('B' + productbegin[product] + ':B' + productend[product] + '');
                    worksheet.mergeCells('C' + productbegin[product] + ':C' + productend[product] + '');
                    worksheet.mergeCells('D' + productbegin[product] + ':D' + productend[product] + '');
                }
            }

            //  设置页脚(默认居中)
            worksheet.headerFooter.oddFooter = "第 &P 页，共 &N 页";

            // 将工作薄导出为excel文件
            workbook.xlsx.writeBuffer().then((item) => {
                const blob = new Blob([item], { type: "EXCEL_TYPE" });
                FileSaver.saveAs(blob, queryCriteria.branchStoreName + " - " + queryCriteria.menuHeadName + moment().format('YYYY-MM-DD') + '.xlsx');
            })
        }
    }

    /**票据数据 */
    if (apiId === "billQuery") {
        console.log("该内容是" + apiId);
        console.log(queryCriteria);

        const { columnsHead } = queryCriteria
        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('票据订单', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });


        worksheet.columns = columnsHead;


        worksheet.addRows(rows)
        worksheet.insertRow(1, ["票据订单"]);
        worksheet.eachRow(function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {


                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 14, name: 'Arial', };
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }

        });


        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);


        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '票据订单.xlsx');
        })

    }

    /**发货日报表 */
    if (apiId === "exDailyReport") {
        console.log("该内容是" + apiId);
        console.log(queryCriteria);
        console.log("rows", rows);

        const { columnsHead, entrepotName, userName } = queryCriteria
        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('报表', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });

        // 1. 解析表头层级
        const parentRow: Array<any> = [];
        const childRow: Array<any> = [];
        const mergeRanges: Array<any> = [];


        columnsHead.forEach((header: any) => {
            if (header.children) {
                // 父级标题直接合并子项数，无需额外空白
                parentRow.push(header.title);
                parentRow.push("");


                // 合并范围仅包含实际子项数
                mergeRanges.push({
                    startCol: parentRow.length - 1, // 从父项当前列开始
                    span: parentRow.length
                });
                // 子项行仅添加实际标题
                childRow.push(...header.children.map((c: any) => c.title));
            } else {
                // 普通列处理
                parentRow.push(header.title);
                childRow.push(''); // 保持行数对齐
            }
        });

        // 添加表头行
        worksheet.addRow(["发货日报表"]);
        worksheet.addRow([`仓库:${entrepotName}`]);
        worksheet.addRow(parentRow);
        worksheet.addRow(childRow);



        // // 3. 动态数据映射
        // rows.forEach((row: any) => {
        //     const rowData = columnsHead.flatMap((header: any) =>
        //         header.children
        //             ? header.children.map((c: any) => row[c.dataIndex])
        //             : [row[header.dataIndex]]
        //     );
        //     console.log("rowData", rowData);

        //     worksheet.addRow(rowData);
        // });
        // 在添加数据行部分增加空单元格补全逻辑
        rows.forEach((row: any) => {
            // 计算总列数（根据表头结构）
            const totalColumns = columnsHead.reduce((sum: any, header: any) =>
                sum + (header.children ? header.children.length : 1), 0);

            // 生成数据并补全空白单元格
            const rowData = [];
            columnsHead.forEach((header: any) => {
                if (header.children) {
                    header.children.forEach((c: any) => {
                        rowData.push(row[c.dataIndex] ?? ''); // 确保无数据时为空白字符串
                    });
                } else {
                    rowData.push(row[header.dataIndex] ?? '');
                }
            });

            // 填充缺失列至总列数（防止数据不足导致后续单元格未生成）
            while (rowData.length < totalColumns) {
                rowData.push('');
            }

            worksheet.addRow(rowData);
        });

        /**合并单元格 */
        mergeRanges.forEach(({ startCol, span }) => {

            worksheet.mergeCells(3, startCol, 3, span); // 合并父级标题[7](@ref)
        });

        /**合并单元格 */
        worksheet.mergeCells(`A1`, `${String.fromCharCode(parentRow.length + 64)}1`);
        worksheet.mergeCells(`A2`, `${String.fromCharCode(parentRow.length + 64)}2`);

        worksheet.mergeCells(`A3`, `A4`);
        worksheet.mergeCells(`B3`, `B4`);

        worksheet.eachRow(function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {


                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 15, name: 'Arial', };
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            }

        });
        // 生成文件...
        let sumEnd = rows.length + 6;
        let finallyRow = worksheet.getRow(sumEnd);

        finallyRow.getCell(1).value = `制表人:${userName}`; // A1 的值设置为"收货统计表"
        finallyRow.getCell(3).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;
        finallyRow.border = {};
        finallyRow.getCell(1).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        finallyRow.getCell(3).alignment = { vertical: "middle", horizontal: "right", wrapText: true };

        worksheet.mergeCells(`A${sumEnd}:B${sumEnd}`)
        worksheet.mergeCells(`C${sumEnd}:${String.fromCharCode(parentRow.length + 64)}${sumEnd}`)
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '发货日报表.xlsx');
        })

    }
    /**收货(调入)日报表 */
    if (apiId === "purDailyReport") {
        console.log("该内容是" + apiId);
        console.log(queryCriteria);
        console.log("rows", rows);

        const { columnsHead, entrepotName, userName } = queryCriteria
        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('报表', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });

        // 1. 解析表头层级
        const parentRow: Array<any> = [];
        const childRow: Array<any> = [];
        const mergeRanges: Array<any> = [];


        columnsHead.forEach((header: any) => {
            if (header.children) {
                // 父级标题直接合并子项数，无需额外空白
                parentRow.push(header.title);
                parentRow.push("");


                // 合并范围仅包含实际子项数
                mergeRanges.push({
                    startCol: parentRow.length - 1, // 从父项当前列开始
                    span: parentRow.length
                });
                // 子项行仅添加实际标题
                childRow.push(...header.children.map((c: any) => c.title));
            } else {
                // 普通列处理
                parentRow.push(header.title);
                childRow.push(''); // 保持行数对齐
            }
        });

        // 添加表头行
        worksheet.addRow(["进货日报表"]);
        worksheet.addRow([`仓库:${entrepotName}`]);

        worksheet.addRow(parentRow);
        worksheet.addRow(childRow);








        // // 3. 动态数据映射
        // rows.forEach((row: any) => {
        //     const rowData = columnsHead.flatMap((header: any) =>
        //         header.children
        //             ? header.children.map((c: any) => row[c.dataIndex])
        //             : [row[header.dataIndex]]
        //     );
        //     console.log("rowData", rowData);

        //     worksheet.addRow(rowData);
        // });
        // 在添加数据行部分增加空单元格补全逻辑
        rows.forEach((row: any) => {
            // 计算总列数（根据表头结构）
            const totalColumns = columnsHead.reduce((sum: any, header: any) =>
                sum + (header.children ? header.children.length : 1), 0);

            // 生成数据并补全空白单元格
            const rowData = [];
            columnsHead.forEach((header: any) => {
                if (header.children) {
                    header.children.forEach((c: any) => {
                        rowData.push(row[c.dataIndex] ?? ''); // 确保无数据时为空白字符串
                    });
                } else {
                    rowData.push(row[header.dataIndex] ?? '');
                }
            });

            // 填充缺失列至总列数（防止数据不足导致后续单元格未生成）
            while (rowData.length < totalColumns) {
                rowData.push('');
            }

            worksheet.addRow(rowData);
        });

        /**合并单元格 */
        mergeRanges.forEach(({ startCol, span }) => {

            worksheet.mergeCells(3, startCol, 3, span); // 合并父级标题[7](@ref)
        });

        /**合并单元格 */
        worksheet.mergeCells(`A1`, `${String.fromCharCode(parentRow.length + 64)}1`);
        worksheet.mergeCells(`A2`, `${String.fromCharCode(parentRow.length + 64)}2`);

        worksheet.mergeCells(`A3`, `A4`);

        worksheet.eachRow(function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {


                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 15, name: 'Arial', };
                row.height = 20;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            }

        });
        // 生成文件...
        let sumEnd = rows.length + 6;
        let finallyRow = worksheet.getRow(sumEnd);

        finallyRow.getCell(1).value = `制表人:${userName}`; // A1 的值设置为"收货统计表"
        finallyRow.getCell(3).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;
        finallyRow.border = {};
        finallyRow.getCell(1).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        finallyRow.getCell(3).alignment = { vertical: "middle", horizontal: "right", wrapText: true };

        worksheet.mergeCells(`A${sumEnd}:B${sumEnd}`)
        worksheet.mergeCells(`C${sumEnd}:${String.fromCharCode(parentRow.length + 64)}${sumEnd}`)
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '进货日报表.xlsx');
        })

    }


    /**进销存统计表 */
    if (apiId === "purchaseSaleStockStatistics") {
        console.log("该内容是" + apiId);
        console.log(queryCriteria);

        const { columnsHead, date, selfs, userName } = queryCriteria
        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('进销存统计表', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });

        // 1. 解析表头层级
        let parentRowFirst = [columnsHead[0].title];
        let lastColumnsHead = columnsHead[0].children

        const parentRow: Array<any> = [];
        const childRow: Array<any> = [];
        const mergeRanges: Array<any> = [];


        lastColumnsHead.forEach((header: any) => {

            if (header.children) {
                // 父级标题直接合并子项数，无需额外空白
                parentRow.push(header.title);
                parentRow.push("");


                // 合并范围仅包含实际子项数
                mergeRanges.push({
                    startCol: parentRow.length - 1, // 从父项当前列开始
                    span: parentRow.length
                });
                // 子项行仅添加实际标题
                childRow.push(...header.children.map((c: any) => c.title));
            } else {
                // 普通列处理
                parentRow.push(header.title);
                childRow.push(''); // 保持行数对齐
            }
        });



        // 添加表头行
        worksheet.addRow(["进销存统计表"]);
        worksheet.addRow(parentRowFirst);
        worksheet.addRow([`日期:${date}`, '', '', '', `品号:${selfs}`, '', '']);


        worksheet.addRow(parentRow);
        worksheet.addRow(childRow);







        // // 3. 动态数据映射
        // rows.forEach((row: any) => {
        //     const rowData = columnsHead.flatMap((header: any) =>
        //         header.children
        //             ? header.children.map((c: any) => row[c.dataIndex])
        //             : [row[header.dataIndex]]
        //     );
        //     console.log("rowData", rowData);

        //     worksheet.addRow(rowData);
        // });
        // 在添加数据行部分增加空单元格补全逻辑
        rows.forEach((row: any) => {
            // 计算总列数（根据表头结构）
            const totalColumns = lastColumnsHead.reduce((sum: any, header: any) =>
                sum + (header.children ? header.children.length : 1), 0);

            // 生成数据并补全空白单元格
            const rowData = [];
            lastColumnsHead.forEach((header: any) => {
                if (header.children) {
                    header.children.forEach((c: any) => {
                        rowData.push(row[c.dataIndex] ?? ''); // 确保无数据时为空白字符串
                    });
                } else {
                    rowData.push(row[header.dataIndex] ?? '');
                }
            });

            // 填充缺失列至总列数（防止数据不足导致后续单元格未生成）
            while (rowData.length < totalColumns) {
                rowData.push('');
            }

            worksheet.addRow(rowData);
        });

        /**合并单元格 */
        mergeRanges.forEach(({ startCol, span }) => {

            worksheet.mergeCells(4, startCol, 4, span); // 合并父级标题[7](@ref)
        });

        /**合并单元格 */
        worksheet.mergeCells(`A1`, `${String.fromCharCode(parentRow.length + 64)}1`);
        worksheet.mergeCells(`A2`, `${String.fromCharCode(parentRow.length + 64)}2`);
        // worksheet.mergeCells(`E2`, `${String.fromCharCode(parentRow.length + 64)}2`);
        worksheet.mergeCells(`A3`, `D3`);
        worksheet.mergeCells(`E3`, `${String.fromCharCode(parentRow.length + 64)}3`);



        worksheet.mergeCells(`A4`, `A5`);
        worksheet.mergeCells(`B4`, `B5`);
        worksheet.mergeCells(`C4`, `C5`);



        worksheet.eachRow(function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {


                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 15, name: 'Arial', };
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }

        });
        // 生成文件...
        let sumEnd = rows.length + 6;
        let finallyRow = worksheet.getRow(sumEnd);

        finallyRow.getCell(1).value = `制表人:${userName}`; // A1 的值设置为"收货统计表"
        finallyRow.getCell(3).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;
        finallyRow.border = {};
        finallyRow.getCell(1).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        finallyRow.getCell(3).alignment = { vertical: "middle", horizontal: "right", wrapText: true };

        worksheet.mergeCells(`A${sumEnd}:B${sumEnd}`)
        worksheet.mergeCells(`C${sumEnd}:${String.fromCharCode(parentRow.length + 64)}${sumEnd}`)

        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '进销存统计表.xlsx');
        })

    }

    /**进销存统计表 */
    if (apiId === 'saleStockStatistics') {
        console.log('该内容是' + apiId);
        console.log(queryCriteria);

        const { columnsHead, date, selfs, userName } = queryCriteria;

        // 创建工作簿
        const workbook = new ExcelJS.Workbook();

        // 添加工作表
        const worksheet = workbook.addWorksheet('进销存统计表', {
            pageSetup: {
                paperSize: 9, // 9 = A4
                orientation: 'portrait',
            },
        });

        // =========================
        // 1. 解析表头并建立列映射
        // =========================
        const lastColumnsHead = columnsHead[0].children;

        const parentRow: Array<any> = [];
        const childRow: Array<any> = [];
        const columnMap: Array<{
            parentTitle: string;
            childTitle: string;
            dataIndex: string;
        }> = [];

        lastColumnsHead.forEach((header: any) => {
            if (header.children && Array.isArray(header.children)) {
                parentRow.push(header.title);
                header.children.forEach((child: any) => {
                    childRow.push(child.title);
                    columnMap.push({
                        parentTitle: header.title,
                        childTitle: child.title,
                        dataIndex: child.dataIndex,
                    });
                });
            } else {
                parentRow.push(header.title);
                childRow.push('');
                columnMap.push({
                    parentTitle: header.title,
                    childTitle: '',
                    dataIndex: header.dataIndex,
                });
            }
        });

        const totalColumns = columnMap.length;

        // =========================
        // 2. 标题区
        // =========================
        worksheet.addRow(['进销存统计表']);
        worksheet.addRow([columnsHead[0].title]);
        worksheet.addRow([`日期:${date ?? ''}`, '', '', '', `品号:${selfs ?? ''}`]);

        // =========================
        // 3. 两级表头
        // =========================
        worksheet.addRow(parentRow);
        worksheet.addRow(childRow);

        // =========================
        // 4. 合并父级表头
        // =========================
        let currentCol = 1;
        lastColumnsHead.forEach((header: any) => {
            if (header.children && header.children.length > 1) {
                worksheet.mergeCells(
                    4,
                    currentCol,
                    4,
                    currentCol + header.children.length - 1,
                );
            }
            currentCol += header.children ? header.children.length : 1;
        });

        // =========================
        // 5. 固定列合并
        // =========================
        worksheet.mergeCells(`A1:${String.fromCharCode(64 + totalColumns)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(64 + totalColumns)}2`);
        worksheet.mergeCells('A3:D3');
        worksheet.mergeCells(`E3:${String.fromCharCode(64 + totalColumns)}3`);
        worksheet.mergeCells('A4:A5');
        worksheet.mergeCells('B4:B5');
        worksheet.mergeCells('C4:C5');

        // =========================
        // 6. 数据行 + 合计统计
        // =========================
        const dataStartRow = 6;

        const summaryFields = [
            'openingQuantity',
            'openingPrice',
            'importQuantity',
            'importPrice',
            'exportQuantity',
            'exportPrice',
            'incomeStatementQuantity',
            'incomeStatementPrice',
            'balanceQuantity',
            'balancePrice',
        ];

        const totals: Record<string, number> = {};
        summaryFields.forEach((key) => {
            totals[key] = 0;
        });

        rows.forEach((row: any) => {
            const rowData: Array<any> = columnMap.map((col) => {
                const value = row[col.dataIndex];
                return value === undefined || value === null ? '' : value;
            });

            worksheet.addRow(rowData);

            // ✅ 原始数据直接合计，不受页面排序影响
            summaryFields.forEach((key) => {
                totals[key] += Number(row[key]) || 0;
            });
        });

        // =========================
        // 7. 合计行（数量 / 金额分别合计）
        // =========================
        const summaryRowNumber = dataStartRow + rows.length;
        const summaryRow = worksheet.getRow(summaryRowNumber);

        // 品号 / 品名 / 单位 → 合计
        worksheet.mergeCells(`A${summaryRowNumber}:C${summaryRowNumber}`);
        summaryRow.getCell(1).value = '合计';

        // 期初
        summaryRow.getCell(4).value = Number(totals.openingQuantity.toFixed(2));
        summaryRow.getCell(5).value = Number(totals.openingPrice.toFixed(2));

        // 本期进货
        summaryRow.getCell(6).value = Number(totals.importQuantity.toFixed(2));
        summaryRow.getCell(7).value = Number(totals.importPrice.toFixed(2));

        // 本期销货
        summaryRow.getCell(8).value = Number(totals.exportQuantity.toFixed(2));
        summaryRow.getCell(9).value = Number(totals.exportPrice.toFixed(2));

        // 本期调整
        summaryRow.getCell(10).value = Number(totals.incomeStatementQuantity.toFixed(2));
        summaryRow.getCell(11).value = Number(totals.incomeStatementPrice.toFixed(2));

        // 本期结存
        summaryRow.getCell(12).value = Number(totals.balanceQuantity.toFixed(2));
        summaryRow.getCell(13).value = Number(totals.balancePrice.toFixed(2));

        // =========================
        // 8. 样式
        // =========================
        worksheet.eachRow((row, rowNumber) => {
            row.eachCell({ includeEmpty: true }, (cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });

            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            }

            // 合计行加粗
            if (rowNumber === summaryRowNumber) {
                row.font = { size: 12, name: 'Arial', bold: true };
            }
        });

        // =========================
        // 9. 制表人 / 打印时间
        // =========================
        const footerRowNumber = summaryRowNumber + 1;
        const footerRow = worksheet.getRow(footerRowNumber);

        footerRow.getCell(1).value = `制表人:${userName ?? ''}`;
        footerRow.getCell(3).value = `打印时间:${moment().format('YYYY-MM-DD HH:mm:ss')}`;

        footerRow.getCell(1).alignment = {
            vertical: 'middle',
            horizontal: 'left',
            wrapText: true,
        };

        footerRow.getCell(3).alignment = {
            vertical: 'middle',
            horizontal: 'right',
            wrapText: true,
        };

        worksheet.mergeCells(`A${footerRowNumber}:B${footerRowNumber}`);
        worksheet.mergeCells(
            `C${footerRowNumber}:${String.fromCharCode(64 + totalColumns)}${footerRowNumber}`,
        );

        // =========================
        // 10. 导出
        // =========================
        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            FileSaver.saveAs(blob, '进销存统计表.xlsx');
        });
    }
    /**产品预警 */
    if (apiId === "warningProduct") {
        console.log("该内容是" + apiId);
        console.log(queryCriteria);

        const { columnsHead, entrepotName } = queryCriteria
        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('产品预警', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });


        worksheet.columns = columnsHead;


        worksheet.addRows(rows)
        worksheet.insertRow(1, [entrepotName]);
        worksheet.eachRow(function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
                //    console.log(cell);
                console.log(rowNumber);
                if (cell.value !== null && cell.value !== undefined && cell.value !== '') {

                } else {
                    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }

                }


                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            }

        });


        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);


        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '产品预警.xlsx');
        })

    }

    /**购买礼品卡 */
    if (apiId === "buyGiftCardReport") {
        console.log("该内容是" + apiId);
        console.log("rows", rows);



        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('购买礼品卡', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };
        let { date, branchStoreName, userName, columnsHead, giftCardStatusName } = queryCriteria;
        worksheet.columns = columnsHead




        let startTime;
        let endTime;

        if (date && date.length > 0) {
            startTime = dayjs(date[0]).format("YYYY-MM-DD")
            endTime = dayjs(date[1]).format("YYYY-MM-DD")

        }

        worksheet.addRows(rows);

        // 将数据插入
        worksheet.insertRow(1, [`门店:${branchStoreName}`, '', "", `状态:${giftCardStatusName}`, '']);
        worksheet.insertRow(1, [`${date ? `日期:${startTime}至${endTime}` : "日期:所有"} `]);
        worksheet.insertRow(1, ["购买礼品卡统计"]);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);

        // 设置标题行的行高
        titlerow.height = 13;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 13;


        // 设置字体
        worksheet.getRow(1).font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };
        // 设置字体
        worksheet.getRow(3).font = {
            name: '宋体',
            family: 4,
            size: 15,
            bold: true
        };
        let sumEnd = rows.length + 6;
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 25, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 20, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 3) {
                row.font = { size: 18, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }


        });

        // 合并单元格
        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(columnsHead.length + 64)}2`);
        worksheet.mergeCells(`A3:C3`);
        worksheet.mergeCells(`D3:${String.fromCharCode(columnsHead.length + 64)}3`);



        let finallyRow = worksheet.getRow(sumEnd);


        worksheet.mergeCells(`A${sumEnd}:C${sumEnd}`)
        worksheet.mergeCells(`D${sumEnd}:${String.fromCharCode(columnsHead.length + 64)}${sumEnd}`);

        finallyRow.getCell(1).value = `制表人:${userName}`;
        finallyRow.getCell(5).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;

        // 居中对齐并自动换行
        // worksheet.getCell('A1').alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        // worksheet.getCell('A2').alignment = { vertical: "middle", horizontal: "center", wrapText: true };

        // worksheet.getCell(`A${sumEnd}`).alignment = { vertical: "middle", horizontal: "justify", wrapText: true };
        // worksheet.getCell(`A3`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        // worksheet.getCell(`F3`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };




        //去除边框线
        worksheet.getRow(1).border = {};
        worksheet.getRow(2).border = {};
        worksheet.getRow(3).border = {};

        worksheet.getRow(sumEnd).border = {};



        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '购买礼品卡统计.xlsx');
        })


    }

    /**核销礼品卡 */
    if (apiId === "writeOffGiftCardReport") {
        console.log("该内容是" + apiId);
        console.log("rows", rows);



        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('核销礼品卡', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };
        let { date, branchStoreName, userName, columnsHead, giftCardStatusName } = queryCriteria;
        worksheet.columns = columnsHead




        let startTime;
        let endTime;

        if (date && date.length > 0) {
            startTime = dayjs(date[0]).format("YYYY-MM-DD")
            endTime = dayjs(date[1]).format("YYYY-MM-DD")

        }

        worksheet.addRows(rows);

        // 将数据插入
        worksheet.insertRow(1, [`门店:${branchStoreName}`, '', "", `状态:${giftCardStatusName}`, '']);
        worksheet.insertRow(1, [`${date ? `日期:${startTime}至${endTime}` : "日期:所有"} `]);
        worksheet.insertRow(1, ["核销礼品卡统计"]);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);

        // 设置标题行的行高
        titlerow.height = 13;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 13;


        // 设置字体
        worksheet.getRow(1).font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };
        // 设置字体
        worksheet.getRow(3).font = {
            name: '宋体',
            family: 4,
            size: 15,
            bold: true
        };
        let sumEnd = rows.length + 6;
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 25, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 18, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 3) {
                row.font = { size: 18, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }


        });

        // 合并单元格
        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(columnsHead.length + 64)}2`);
        worksheet.mergeCells(`A3:C3`);
        worksheet.mergeCells(`D3:${String.fromCharCode(columnsHead.length + 64)}3`);



        let finallyRow = worksheet.getRow(sumEnd);


        worksheet.mergeCells(`A${sumEnd}:C${sumEnd}`)
        worksheet.mergeCells(`D${sumEnd}:${String.fromCharCode(columnsHead.length + 64)}${sumEnd}`);

        finallyRow.getCell(1).value = `制表人:${userName}`;
        finallyRow.getCell(5).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;

        // 居中对齐并自动换行
        // worksheet.getCell('A1').alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        // worksheet.getCell('A2').alignment = { vertical: "middle", horizontal: "center", wrapText: true };

        // worksheet.getCell(`A${sumEnd}`).alignment = { vertical: "middle", horizontal: "justify", wrapText: true };
        // worksheet.getCell(`A3`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        // worksheet.getCell(`F3`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };




        //去除边框线
        worksheet.getRow(1).border = {};
        worksheet.getRow(2).border = {};
        worksheet.getRow(3).border = {};

        worksheet.getRow(sumEnd).border = {};



        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '核销礼品卡统计.xlsx');
        })


    }

    /**退款礼品卡 */
    if (apiId === "refundGiftCardReport") {
        console.log("该内容是" + apiId);
        console.log("rows", rows);



        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('退款礼品卡', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };
        let { date, branchStoreName, userName, columnsHead, giftCardStatusName } = queryCriteria;
        worksheet.columns = columnsHead




        let startTime;
        let endTime;

        if (date && date.length > 0) {
            startTime = dayjs(date[0]).format("YYYY-MM-DD")
            endTime = dayjs(date[1]).format("YYYY-MM-DD")

        }

        worksheet.addRows(rows);

        // 将数据插入
        worksheet.insertRow(1, [`门店:${branchStoreName}`, '', "", `状态:${giftCardStatusName}`, '']);
        worksheet.insertRow(1, [`${date ? `日期:${startTime}至${endTime}` : "日期:所有"} `]);
        worksheet.insertRow(1, ["退款礼品卡统计"]);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);

        // 设置标题行的行高
        titlerow.height = 13;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 13;


        // 设置字体
        worksheet.getRow(1).font = {
            name: '宋体',
            family: 4,
            size: 20,
            bold: true
        };
        // 设置字体
        worksheet.getRow(3).font = {
            name: '宋体',
            family: 4,
            size: 15,
            bold: true
        };
        let sumEnd = rows.length + 6;
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 25, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 18, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 3) {
                row.font = { size: 18, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }


        });

        // 合并单元格
        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(columnsHead.length + 64)}2`);
        worksheet.mergeCells(`A3:C3`);
        worksheet.mergeCells(`D3:${String.fromCharCode(columnsHead.length + 64)}3`);



        let finallyRow = worksheet.getRow(sumEnd);


        worksheet.mergeCells(`A${sumEnd}:C${sumEnd}`)
        worksheet.mergeCells(`D${sumEnd}:${String.fromCharCode(columnsHead.length + 64)}${sumEnd}`);

        finallyRow.getCell(1).value = `制表人:${userName}`;
        finallyRow.getCell(5).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;

        // 居中对齐并自动换行
        // worksheet.getCell('A1').alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        // worksheet.getCell('A2').alignment = { vertical: "middle", horizontal: "center", wrapText: true };

        // worksheet.getCell(`A${sumEnd}`).alignment = { vertical: "middle", horizontal: "justify", wrapText: true };
        // worksheet.getCell(`A3`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        // worksheet.getCell(`F3`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };




        //去除边框线
        worksheet.getRow(1).border = {};
        worksheet.getRow(2).border = {};
        worksheet.getRow(3).border = {};

        worksheet.getRow(sumEnd).border = {};



        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '退款礼品卡统计.xlsx');
        })


    }


    if (apiId === "giftCardReport") {
        console.log("该内容是" + apiId);
        console.log("rows", rows);



        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('礼品卡', {
            pageSetup: {
                paperSize: 9, orientation: "portrait",
                fitToPage: true,    // 启用缩放以适应页面
                fitToWidth: 1,      // 宽度缩放至1页内
            }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // worksheet.addRow(["xxx"]);
        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };
        let { date, branchStoreName, userName, columnsHead } = queryCriteria;

        worksheet.columns = columnsHead




        let startTime;
        let endTime;

        if (date && date.length > 0) {
            startTime = dayjs(date[0]).format("YYYY-MM-DD")
            endTime = dayjs(date[1]).format("YYYY-MM-DD")

        }

        worksheet.addRows(rows);

        // 将数据插入
        // worksheet.insertRow(1, [`门店:${branchStoreName}`]);
        worksheet.insertRow(1, [`${date ? `日期:${startTime}至${endTime}` : "日期:所有"} `, "", '', '', `门店:${branchStoreName}`]);
        worksheet.insertRow(1, ["礼品卡统计"]);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);

        // 设置标题行的行高
        titlerow.height = 13;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 13;



        let sumEnd = rows.length + 4;
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 20, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 25;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            }


        });

        // 合并单元格
        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:D2`);
        worksheet.mergeCells(`E2:${String.fromCharCode(columnsHead.length + 64)}2`);




        let finallyRow = worksheet.getRow(sumEnd);


        worksheet.mergeCells(`A${sumEnd}:C${sumEnd}`)
        worksheet.mergeCells(`D${sumEnd}:${String.fromCharCode(columnsHead.length + 64)}${sumEnd}`);

        finallyRow.getCell(1).value = `制表人:${userName}`;
        finallyRow.getCell(7).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;

        // 居中对齐并自动换行
        // worksheet.getCell('A1').alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        // worksheet.getCell('A2').alignment = { vertical: "middle", horizontal: "center", wrapText: true };

        // worksheet.getCell(`A${sumEnd}`).alignment = { vertical: "middle", horizontal: "justify", wrapText: true };
        // worksheet.getCell(`A3`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        // worksheet.getCell(`F3`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };




        //去除边框线
        worksheet.getRow(1).border = {};
        worksheet.getRow(2).border = {};

        worksheet.getRow(sumEnd).border = {};



        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '礼品卡统计.xlsx');
        })


    }
    /**会员汇总计表 */
    if (apiId === "memberSummary") {
        console.log("该内容是" + apiId);
        console.log(queryCriteria);


        let { columnsHead, date, branchStoreName } = queryCriteria;


        date = date ? `${moment(date[0]).format("YYYY-MM-DD")}~${moment(date[1]).format("YYYY-MM-DD")}` : "所有";
        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('会员汇总', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });

        // 1. 解析表头层级

        const parentRow: Array<any> = [];
        const childRow: Array<any> = [];
        const mergeRanges: Array<any> = [];


        columnsHead.forEach((header: any) => {

            if (header.children) {
                // 父级标题直接合并子项数，无需额外空白
                parentRow.push(header.title);
                let startCol = parentRow.length;
                let length = header.children.length - 1;

                for (let i = 0; i < length; i++) {
                    parentRow.push("");

                }




                // 合并范围仅包含实际子项数
                mergeRanges.push({
                    startCol, // 从父项当前列开始
                    span: parentRow.length
                });
                // 子项行仅添加实际标题
                childRow.push(...header.children.map((c: any) => c.title));
            } else {
                // 普通列处理
                parentRow.push(header.title);
                childRow.push(''); // 保持行数对齐
            }
        });
        // 添加表头行
        worksheet.addRow(["会员汇总"]);
        worksheet.addRow([`日期:${date}`, '', '', '', '', '', `门店:${branchStoreName}`]);



        worksheet.addRow(parentRow);
        worksheet.addRow(childRow);

        // 在添加数据行部分增加空单元格补全逻辑
        rows.forEach((row: any) => {
            // 计算总列数（根据表头结构）
            const totalColumns = columnsHead.reduce((sum: any, header: any) =>
                sum + (header.children ? header.children.length : 1), 0);

            // 生成数据并补全空白单元格
            const rowData = [];
            columnsHead.forEach((header: any) => {
                if (header.children) {
                    header.children.forEach((c: any) => {
                        rowData.push(row[c.dataIndex] ?? ''); // 确保无数据时为空白字符串
                    });
                } else {
                    rowData.push(row[header.dataIndex] ?? '');
                }
            });

            // 填充缺失列至总列数（防止数据不足导致后续单元格未生成）
            while (rowData.length < totalColumns) {
                rowData.push('');
            }

            worksheet.addRow(rowData);
        });

        /**合并单元格 */
        mergeRanges.forEach(({ startCol, span }) => {

            worksheet.mergeCells(3, startCol, 3, span); // 合并父级标题[7](@ref)
        });

        /**合并单元格 */
        worksheet.mergeCells(`A1`, `${String.fromCharCode(parentRow.length + 64)}1`);
        worksheet.mergeCells(`A2`, `F2`);
        worksheet.mergeCells(`G2`, `${String.fromCharCode(parentRow.length + 64)}2`);








        worksheet.eachRow(function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {


                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 15, name: 'Arial', };
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }

        });
        // 生成文件...
        // let sumEnd = rows.length + 6;
        // let finallyRow = worksheet.getRow(sumEnd);

        // finallyRow.getCell(1).value = `制表人:${userName}`; // A1 的值设置为"收货统计表"
        // finallyRow.getCell(3).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;
        // finallyRow.border = {};
        // finallyRow.getCell(1).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        // finallyRow.getCell(3).alignment = { vertical: "middle", horizontal: "right", wrapText: true };

        // worksheet.mergeCells(`A${sumEnd}:B${sumEnd}`)
        // worksheet.mergeCells(`C${sumEnd}:${String.fromCharCode(parentRow.length + 64)}${sumEnd}`)

        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '会员汇总表.xlsx');
        })

    }


    /**会员余额表 */
    if (apiId === "memberBalance") {
        console.log("该内容是" + apiId);
        console.log(queryCriteria);
        console.log("rows", rows);


        let { columnsHead, branchStoreName } = queryCriteria;


        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('会员余额', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });


        worksheet.columns = columnsHead;




        // 添加表头行
        worksheet.insertRow(1, [`门店:${branchStoreName}`]);
        worksheet.insertRow(1, ["会员余额"]);







        worksheet.addRows(rows);
        /**合并单元格 */
        worksheet.mergeCells(`A1`, `${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2`, `${String.fromCharCode(columnsHead.length + 64)}2`);




        worksheet.eachRow(function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {


                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 15, name: 'Arial', };
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }

        });

        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '会员余额表.xlsx');
        })

    }


    /**仓库收货商品*/
    if (apiId === "purOrderQuery") {
        let { time, entrepotName } = queryCriteria;
        time = time ? `${time.startTime}-${time.endTime}` : "所有";

        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('收货商品', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });

        // 1. 解析表头层级

        let columns = [
            { header: '日期', width: 15, key: "createdAt" },

            { header: '产品', width: 15, key: "productName" },
            { header: '单位', width: 15, key: "productUnitName", },
            { header: '规格', width: 15, key: "productSpecifications", },
            { header: '数量', width: 15, key: "bNum", },
            { header: '单价', width: 15, key: "univalence" },
            { header: '金额', width: 15, key: "totalPrice", },
            { header: '备注', width: 15, key: "memo", },
        ]
        worksheet.columns = columns;
        // 添加表头行

        worksheet.addRows(rows);
        worksheet.insertRow(1, [`日期:${time}`, '', '', '', `仓库:${entrepotName}`, '', '',]);
        worksheet.insertRow(1, ["收货商品"]);


        /**合并单元格 */
        worksheet.mergeCells(`A1`, `${String.fromCharCode(columns.length + 64)}1`);
        worksheet.mergeCells(`A2`, `D2`);
        worksheet.mergeCells(`E2`, `${String.fromCharCode(columns.length + 64)}2`);








        worksheet.eachRow(function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {


                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 15, name: 'Arial', };
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }

        });
        // 生成文件...
        // let sumEnd = rows.length + 6;
        // let finallyRow = worksheet.getRow(sumEnd);

        // finallyRow.getCell(1).value = `制表人:${userName}`; // A1 的值设置为"收货统计表"
        // finallyRow.getCell(3).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;
        // finallyRow.border = {};
        // finallyRow.getCell(1).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        // finallyRow.getCell(3).alignment = { vertical: "middle", horizontal: "right", wrapText: true };

        // worksheet.mergeCells(`A${sumEnd}:B${sumEnd}`)
        // worksheet.mergeCells(`C${sumEnd}:${String.fromCharCode(parentRow.length + 64)}${sumEnd}`)

        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '收货商品.xlsx');
        })

    }
    if (apiId === "quotationComparisonTwo") {
        console.log("该内容是" + apiId);
        console.log("rows", rows);

        console.log("queryCriteria", queryCriteria);


        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('报价统计对比', {
            pageSetup: {
                paperSize: 9,
                fitToPage: true,    // 启用缩放以适应页面
                fitToWidth: 1,      // 宽度缩放至1页内
            }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };
        let { date, userName, columnsHead } = queryCriteria;

        worksheet.columns = columnsHead




        let startTime;
        let endTime;

        if (date && date.length > 0) {
            startTime = dayjs(date[0]).format("YYYY-MM-DD")
            endTime = dayjs(date[1]).format("YYYY-MM-DD")

        }

        worksheet.addRows(rows);

        // 将数据插入
        worksheet.insertRow(1, [`${date ? `日期:${startTime}至${endTime}` : "日期:所有"} `]);
        worksheet.insertRow(1, ["报价对比"]);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);

        // 设置标题行的行高
        titlerow.height = 13;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 13;



        let sumEnd = rows.length + 4;
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            // ✅ 关键：强制遍历到最后一列（而不是只遍历有数据的列）
            const lastCol = worksheet.columnCount;

            for (let colNumber = 1; colNumber <= lastCol; colNumber++) {
                let cell = row.getCell(colNumber);

                // ✅ 确保单元格存在（空单元格也会被创建）
                if (!cell.value) {
                    cell.value = "";
                }

                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            }

            if (rowNumber === 1) {
                row.font = { size: 20, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 25;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            }
        });

        // 合并单元格
        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(columnsHead.length + 64)}2`);

        // worksheet.mergeCells(`E2:${String.fromCharCode(columnsHead.length + 64)}2`);




        let finallyRow = worksheet.getRow(sumEnd);


        // worksheet.mergeCells(`A${sumEnd}:C${sumEnd}`)
        // worksheet.mergeCells(`D${sumEnd}:${String.fromCharCode(columnsHead.length + 64)}${sumEnd}`);

        finallyRow.getCell(sumEnd - 2).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;

        // 居中对齐并自动换行
        // worksheet.getCell('A1').alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        // worksheet.getCell('A2').alignment = { vertical: "middle", horizontal: "center", wrapText: true };

        // worksheet.getCell(`A${sumEnd}`).alignment = { vertical: "middle", horizontal: "justify", wrapText: true };
        // worksheet.getCell(`A3`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        // worksheet.getCell(`F3`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };




        //去除边框线
        // worksheet.getRow(1).border = {};
        // worksheet.getRow(2).border = {};

        worksheet.getRow(sumEnd).border = {};



        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '对比统计.xlsx');
        })


    }

    if (apiId === "buyerComparison") {
        console.log("该内容是" + apiId);
        console.log("rows", rows);

        console.log("queryCriteria", queryCriteria);


        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('单采购商价格对比', {
            pageSetup: {
                paperSize: 9,
                fitToPage: true,    // 启用缩放以适应页面
                fitToWidth: 1,      // 宽度缩放至1页内
            }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });
        // 创建表头
        /**
         * header: 显示的内容
         * key: 设置一个唯一的key作为属性名，添加行数据时与之对应
         * width: 设置单元格的宽
         */

        // 调整页面设置配置
        worksheet.pageSetup.margins = {
            left: 0.4, right: 0.3,
            top: 0.5, bottom: 0.5,
            header: 0.3, footer: 0.3
        };
        let { date, userName, columnsHead } = queryCriteria;

        worksheet.columns = columnsHead




        let startTime;
        let endTime;

        if (date && date.length > 0) {
            startTime = dayjs(date[0]).format("YYYY-MM-DD")
            endTime = dayjs(date[1]).format("YYYY-MM-DD")

        }

        worksheet.addRows(rows);

        // 将数据插入
        worksheet.insertRow(1, [`${date ? `日期:${startTime}至${endTime}` : "日期:所有"} `]);
        worksheet.insertRow(1, ["单采购商价格对比"]);
        // 获取一个行对象。
        const titlerow = worksheet.getRow(1);

        // 设置标题行的行高
        titlerow.height = 13;

        const searchParameterrow = worksheet.getRow(2);
        // 设置第二行(搜索参数)的行高
        searchParameterrow.height = 13;



        let sumEnd = rows.length + 4;
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            // ✅ 关键：强制遍历到最后一列（而不是只遍历有数据的列）
            const lastCol = worksheet.columnCount;

            for (let colNumber = 1; colNumber <= lastCol; colNumber++) {
                let cell = row.getCell(colNumber);

                // ✅ 确保单元格存在（空单元格也会被创建）
                if (!cell.value) {
                    cell.value = "";
                }

                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            }

            if (rowNumber === 1) {
                row.font = { size: 20, name: 'Arial', bold: true };
                row.height = 30;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 25;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            }
        });

        // 合并单元格
        worksheet.mergeCells(`A1:${String.fromCharCode(columnsHead.length + 64)}1`);
        worksheet.mergeCells(`A2:${String.fromCharCode(columnsHead.length + 64)}2`);

        // worksheet.mergeCells(`E2:${String.fromCharCode(columnsHead.length + 64)}2`);




        let finallyRow = worksheet.getRow(sumEnd);


        // worksheet.mergeCells(`A${sumEnd}:C${sumEnd}`)
        // worksheet.mergeCells(`D${sumEnd}:${String.fromCharCode(columnsHead.length + 64)}${sumEnd}`);

        finallyRow.getCell(sumEnd - 6).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;

        // 居中对齐并自动换行
        // worksheet.getCell('A1').alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
        // worksheet.getCell('A2').alignment = { vertical: "middle", horizontal: "center", wrapText: true };

        // worksheet.getCell(`A${sumEnd}`).alignment = { vertical: "middle", horizontal: "justify", wrapText: true };
        // worksheet.getCell(`A3`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        // worksheet.getCell(`F3`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };




        //去除边框线
        // worksheet.getRow(1).border = {};
        // worksheet.getRow(2).border = {};

        worksheet.getRow(sumEnd).border = {};



        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '单采购商价格对比.xlsx');
        })


    }


    if (apiId === "quotationOrder") {
        let { quotationOrderProducts, buyerName, contact } = rows

        // 修改这部分代码
        // ... 前面的参数定义 ...
        let fileName = '报价单.xlsx',
            sheetName = '报价单',
            title = '产品报价单',
            itemsPerColumn = 50,  // 每列最多显示20行
            columnsPerPage = 2,    // 每页显示2列
            showHeader = true,
            showBorder = true,
            autoWidth = true,
            includeSerialNumber = false // 是否包含序号
        // 创建工作簿
        const workbook = new ExcelJS.Workbook();
        workbook.creator = '报价系统';
        workbook.lastModifiedBy = '用户';
        workbook.created = new Date();


        // 创建工作表
        const worksheet = workbook.addWorksheet(sheetName);

        // 设置A4纸页面属性
        worksheet.pageSetup = {
            paperSize: 9, // 9 = A4
            orientation: 'portrait', // 纵向
            fitToPage: true,
            fitToWidth: 1,
            fitToHeight: 0,
            margins: {
                left: 0.7,
                right: 0.7,
                top: 0.75,
                bottom: 0.75,
                header: 0.3,
                footer: 0.3
            },

        };
        // 表头定义
        const headers = [];
        // if (includeSerialNumber) {
        //     headers.push('序号');
        // }
        headers.push('产品名称', '单价', '单位', '规格');

        // 分栏计算
        const totalItems = quotationOrderProducts.length;
        const totalColumns = Math.ceil(totalItems / itemsPerColumn);
        const pages = Math.ceil(totalColumns / columnsPerPage);

        console.log(`数据统计: 总条数=${totalItems}, 总列数=${totalColumns}, 总页数=${pages}`);

        // 当前写入位置
        let currentRow = title ? 4 : 1; // 跳过标题行

        // 遍历每一页
        for (let page = 0; page < pages; page++) {
            const startColumn = page * columnsPerPage;
            const endColumn = Math.min(startColumn + columnsPerPage, totalColumns);
            const columnsInThisPage = endColumn - startColumn;

            // 计算每页需要的总列数（包括间隔列）
            const columnsWithGaps = columnsInThisPage * (headers.length + 1) - 1;

            // 添加页码标题
            if (pages >= 1) {
                const pageTitleRow = worksheet.addRow([`${buyerName ? `采购商:${buyerName}` : `客户:${contact}`}`]);
                pageTitleRow.font = {
                    bold: true,
                    color: { argb: '366092' },
                    name: '微软雅黑',
                    size: 12
                };
                pageTitleRow.alignment = {
                    horizontal: 'center',
                    vertical: 'middle'
                };
                worksheet.mergeCells(
                    `${getExcelColumn(1)}${currentRow}:${getExcelColumn(columnsWithGaps)}${currentRow}`
                );
                currentRow++;
            }

            // 添加表头（包含空列间隔）
            if (showHeader) {
                const headerRow = [];

                // 为每一栏添加表头
                for (let col = 0; col < columnsInThisPage; col++) {
                    // 添加表头
                    headerRow.push(...headers);

                    // 如果不是最后一列，添加一个空列作为间隔
                    if (col < columnsInThisPage - 1) {
                        headerRow.push(''); // 空列
                    }
                }

                const headerExcelRow = worksheet.addRow(headerRow);

                // 设置表头样式
                headerExcelRow.eachCell((cell, colNumber) => {
                    // 设置表头样式（除了空列）
                    if (cell.value !== '') {
                        cell.font = {
                            bold: true,
                            color: { argb: 'FFFFFF' },
                            name: '微软雅黑',
                            size: 11
                        };
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: '366092' } // 蓝色背景
                        };
                    }

                    cell.alignment = {
                        vertical: 'middle',
                        horizontal: 'center'
                    };

                    if (showBorder) {
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    }
                });

                currentRow++;
            }

            // 添加数据行
            for (let row = 0; row < itemsPerColumn; row++) {
                const dataRow = [];
                let hasData = false;

                for (let pageCol = 0; pageCol < columnsInThisPage; pageCol++) {
                    const columnIndex = startColumn + pageCol;
                    const itemIndex = columnIndex * itemsPerColumn + row;

                    if (itemIndex < totalItems) {
                        hasData = true;
                        const item = quotationOrderProducts[itemIndex];

                        // 添加数据
                        // if (includeSerialNumber) {
                        //     dataRow.push(row + 1); // 序号
                        // }
                        dataRow.push(
                            item.productName || '',
                            item.univalence || 0,
                            item.productUnitName || '',
                            item.productSpecifications || ''
                        );

                        // 如果不是最后一列，添加一个空列作为间隔
                        if (pageCol < columnsInThisPage - 1) {
                            dataRow.push(''); // 空列间隔
                        }
                    } else {
                        // 填充空值
                        const emptyCells = new Array(headers.length).fill('');
                        dataRow.push(...emptyCells);

                        // 如果不是最后一列，添加一个空列作为间隔
                        if (pageCol < columnsInThisPage - 1) {
                            dataRow.push(''); // 空列间隔
                        }
                    }
                }

                if (hasData) {
                    const excelRow = worksheet.addRow(dataRow);

                    // 设置数据行样式
                    excelRow.eachCell((cell, colNumber) => {
                        // 设置对齐方式（只对有数据的列）
                        if (cell.value !== '') {
                            // 计算当前列属于哪一组（每组有 headers.length + 1 列，+1是间隔列）
                            const groupIndex = Math.floor((colNumber - 1) / (headers.length + 1));
                            const colInGroup = (colNumber - 1) % (headers.length + 1);

                            // 如果是间隔列（每组最后一列），跳过样式设置
                            if (colInGroup === headers.length) {
                                return; // 间隔列不设置特殊样式
                            }

                            if (colInGroup === (includeSerialNumber ? 0 : -1)) { // 第一列（序号或产品名称）
                                cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                };
                            } else if (colInGroup === (includeSerialNumber ? 2 : 1)) { // 单价列
                                cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'right'
                                };
                                // 设置数字格式
                                if (typeof cell.value === 'number') {
                                    cell.numFmt = '#,##0.00';
                                }
                            } else {
                                cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'center'
                                };
                            }
                        }

                        // 交替行背景色（不包括间隔列）
                        if (row % 2 === 1 && cell.value !== '') {
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'F2F2F2' }
                            };
                        }

                        if (showBorder) {
                            cell.border = {
                                top: { style: 'thin' },
                                left: { style: 'thin' },
                                bottom: { style: 'thin' },
                                right: { style: 'thin' }
                            };
                        }
                    });

                    currentRow++;
                }
            }

            // 添加分隔行
            // worksheet.addRow([]);

            // 计算本页统计数据
            // const pageStartItem = startColumn * itemsPerColumn;
            // const pageEndItem = Math.min(endColumn * itemsPerColumn, totalItems);
            // const pageItemCount = pageEndItem - pageStartItem;

            // const statsRow = worksheet.addRow([`本页统计: 第 ${pageStartItem + 1}-${pageEndItem} 条，共 ${pageItemCount} 条记录`]);
            // statsRow.font = {
            //     name: '宋体',
            //     size: 10,
            //     italic: true,
            //     color: { argb: '666666' }
            // };

            // 合并统计行的单元格（包括间隔列）
            worksheet.mergeCells(
                `${getExcelColumn(1)}${currentRow}:${getExcelColumn(columnsWithGaps)}${currentRow}`
            );
            // statsRow.alignment = { horizontal: 'center' };
            currentRow++;

            // 如果不是最后一页，添加分页分隔线
            if (page < pages - 1) {
                // 添加水平分页线
                // const pageBreakRow = worksheet.addRow(['════════════════ 下一页 ════════════════']);
                // pageBreakRow.font = {
                //     name: '宋体',
                //     size: 9,
                //     color: { argb: '999999' },
                //     italic: true
                // };
                // pageBreakRow.alignment = { horizontal: 'center' };

                // 合并单元格（包括间隔列）
                worksheet.mergeCells(
                    `${getExcelColumn(1)}${currentRow}:${getExcelColumn(columnsWithGaps)}${currentRow}`
                );
                currentRow++;

                // 添加几行空白作为页间距
                for (let i = 0; i < 2; i++) {
                    worksheet.addRow([]);
                    currentRow++;
                }
            } else {
                // 创建采购、成本、仓库行
                const signRowData = new Array(columnsWithGaps).fill('');

                // 采购放在最左边
                signRowData[0] = '采购:';

                // 成本放在中间
                const middleIndex = Math.floor(columnsWithGaps / 3);
                signRowData[middleIndex] = '成本:';

                // 仓库放在最右边
                signRowData[columnsWithGaps - 1] = '仓库:';

                const signRow = worksheet.addRow(signRowData);

                // 设置整行字体样式
                // signRow.eachCell((cell, colNumber) => {
                //     if (cell.value && cell.value.includes(':')) {
                //         cell.font = {
                //             name: '微软雅黑',
                //             size: 12,
                //             bold: true
                //         };
                //     }
                // });

                // 分别设置对齐方式
                if (signRowData[0] !== '') {
                    signRow.getCell(1).alignment = { horizontal: 'left' };
                }

                if (signRowData[middleIndex] !== '') {
                    signRow.getCell(middleIndex + 1).alignment = { horizontal: 'center' };
                }

                if (signRowData[columnsWithGaps - 1] !== '') {
                    signRow.getCell(columnsWithGaps).alignment = { horizontal: 'left' };
                }

                // 添加总计行
                // const totalRow = worksheet.addRow([`总计: ${totalItems} 条产品记录`]);
                // totalRow.font = {
                //     name: '微软雅黑',
                //     size: 12,
                //     bold: true,
                //     color: { argb: 'FF0000' }
                // };
                // totalRow.alignment = { horizontal: 'center' };

                // 合并单元格（包括间隔列）
                worksheet.mergeCells(
                    `${getExcelColumn(1)}${currentRow + 1}:${getExcelColumn(columnsWithGaps)}${currentRow + 1}`
                );
            }
        }

        // 自动调整列宽
        if (autoWidth) {
            // 需要考虑到间隔列
            const columnsPerGroup = headers.length + 1; // 每组列数（包括间隔列）

            worksheet.columns.forEach((column, index) => {
                if (column.values) {
                    // 计算当前列在组内的位置
                    const groupIndex = Math.floor(index / columnsPerGroup);
                    const colInGroup = index % columnsPerGroup;

                    // 如果是间隔列（每组最后一列），设置较小的宽度
                    if (colInGroup === headers.length) {
                        column.width = 2; // 间隔列宽度
                        return;
                    }

                    let maxLength = 0;
                    column.values.forEach(value => {
                        if (value !== null && value !== undefined) {
                            const valueLength = value.toString().length;
                            if (valueLength > maxLength) {
                                maxLength = valueLength;
                            }
                        }
                    });

                    // 根据列类型设置不同宽度
                    if (colInGroup === (includeSerialNumber ? 1 : 0)) {
                        // 产品名称列
                        column.width = Math.min(Math.max(maxLength, 15), 30);
                    } else if (colInGroup === (includeSerialNumber ? 2 : 1)) {
                        // 单价列
                        column.width = 8;
                    } else if (colInGroup === (includeSerialNumber ? 3 : 2)) {
                        // 单位列
                        column.width = 8;
                    } else {
                        // 规格列
                        column.width = Math.min(Math.max(maxLength, 10), 25);
                    }
                }
            });
        }

        // 设置打印区域
        const lastRowNumber = worksheet.rowCount;
        const lastColumnNumber = columnsPerPage * (headers.length + 1) - 1; // 减1因为最后一列没有间隔列
        const lastColumnLetter = getExcelColumn(lastColumnNumber);
        worksheet.pageSetup.printArea = `A1:${lastColumnLetter}${lastRowNumber}`;

        // 生成并保存文件
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        FileSaver.saveAs(blob, fileName);

        console.log(`Excel文件已生成: ${fileName}`);
        return true;

    };
    if (apiId === "takeStockOrder") {
        let { takeStockProducts, recheckUserName, takeStockOrderName, userName, deptName, sysDate } = rows;

        let fileName = '盘点单.xlsx',
            sheetName = '盘点单',
            title = '盘点单',
            itemsPerColumn = 42,
            columnsPerPage = 2,
            showHeader = true,
            showBorder = true,
            autoWidth = true;

        const workbook = new ExcelJS.Workbook();
        workbook.creator = '盘点单';
        workbook.lastModifiedBy = '用户';
        workbook.created = new Date();

        const worksheet = workbook.addWorksheet(sheetName);

        worksheet.pageSetup = {
            paperSize: 9,
            orientation: 'portrait',
            fitToPage: true,
            fitToWidth: 1,
            fitToHeight: 0,
            margins: {
                left: 0.4, right: 0.3,
                top: 0.2, bottom: 0.5,
                header: 0.3, footer: 0.3
            }

        };

        const headers = ['品名', '单位', '数量', '单价', '金额'];
        const headerCount = headers.length;

        const totalItems = takeStockProducts.length;
        const totalColumns = Math.ceil(totalItems / itemsPerColumn);
        const pages = Math.ceil(totalColumns / columnsPerPage);

        console.log(`数据统计: 总条数=${totalItems}, 总列数=${totalColumns}, 总页数=${pages}`);

        function getExcelColumn(num: any) {
            let s = '';
            while (num > 0) {
                num--;
                s = String.fromCharCode(65 + (num % 26)) + s;
                num = Math.floor(num / 26);
            }
            return s;
        }

        let currentRow = 1;

        for (let page = 0; page < pages; page++) {
            const startColumn = page * columnsPerPage;
            const endColumn = Math.min(startColumn + columnsPerPage, totalColumns);
            const columnsInThisPage = endColumn - startColumn;
            const totalColumnsInPage = columnsInThisPage * (headerCount + 1) - 1;
            const lastColLetter = getExcelColumn(totalColumnsInPage);

            // ===== 1. 标题行 =====
            const titleRow = worksheet.addRow([title]);
            worksheet.mergeCells(`A${currentRow}:${lastColLetter}${currentRow}`);
            titleRow.font = { bold: true, size: 18, name: '微软雅黑' };
            titleRow.alignment = { horizontal: 'center', vertical: 'middle' };
            titleRow.height = 20;
            currentRow++;

            // ===== 2. 部门+日期+页码行 =====
            const pageInfo = pages > 1 ? `    第${page + 1}/${pages}页` : '';
            const infoRow = worksheet.addRow([`部门：${takeStockOrderName ? takeStockOrderName : deptName}    盘点日期：${moment(sysDate.createdAt).format("YYYY-MM-DD")}${pageInfo}`]);
            worksheet.mergeCells(`A${currentRow}:${lastColLetter}${currentRow}`);
            infoRow.font = { size: 11, name: '微软雅黑', color: { argb: '333333' } };
            infoRow.alignment = { horizontal: 'center', vertical: 'middle' };
            infoRow.height = 18;
            currentRow++;

            // ===== 3. 表头行（分栏）=====
            if (showHeader) {
                const headerData = [];
                for (let col = 0; col < columnsInThisPage; col++) {
                    headerData.push(...headers);
                    if (col < columnsInThisPage - 1) headerData.push('');
                }
                const headerRow = worksheet.addRow(headerData);
                headerRow.height = 18;
                headerRow.eachCell((cell, colNumber) => {
                    if (cell.value !== '') {
                        cell.font = { bold: true, color: { argb: 'FFFFFF' }, name: '微软雅黑', size: 10 };
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4472C4' } };
                    }
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                    if (showBorder) {
                        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                    }
                });
                currentRow++;
            }

            // ===== 4. 数据行（分栏）=====
            for (let row = 0; row < itemsPerColumn; row++) {
                const dataRow = [];
                let hasData = false;

                for (let pageCol = 0; pageCol < columnsInThisPage; pageCol++) {
                    const columnIndex = startColumn + pageCol;
                    const itemIndex = columnIndex * itemsPerColumn + row;

                    if (itemIndex < totalItems) {
                        hasData = true;
                        const item = takeStockProducts[itemIndex];
                        dataRow.push(
                            item.product?.productName || '',
                            item.product?.productUnit?.productUnitName || '',
                            item.bNum || 0,
                            item.univalence || 0,
                            item.totalPrice || 0
                        );
                    } else {
                        dataRow.push('', '', '', '', '');
                    }
                    if (pageCol < columnsInThisPage - 1) dataRow.push('');
                }

                if (hasData) {
                    const excelRow = worksheet.addRow(dataRow);
                    excelRow.height = 16;
                    excelRow.eachCell((cell, colNumber) => {
                        const colInGroup = (colNumber - 1) % (headerCount + 1);
                        if (colInGroup === headerCount) return; // 间隔列

                        if (colInGroup === 0) {
                            cell.alignment = { vertical: 'middle', horizontal: 'left' };
                        } else if (colInGroup === 3 || colInGroup === 4) {
                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                            if (typeof cell.value === 'number') cell.numFmt = '#,##0.00';
                        } else {
                            cell.alignment = { vertical: 'middle', horizontal: 'center' };
                        }
                        if (row % 2 === 1) {
                            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F7FB' } };
                        }
                        if (showBorder) {
                            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                        }
                    });
                    currentRow++;
                }
            }

            // ===== 5. 合计行（分栏，每栏各一个合计）=====
            const totalData = [];
            for (let col = 0; col < columnsInThisPage; col++) {
                // 计算该栏的数据范围
                const colStart = (startColumn + col) * itemsPerColumn;
                const colEnd = Math.min(colStart + itemsPerColumn, totalItems);
                let colQty = 0, colAmt = 0;
                for (let i = colStart; i < colEnd; i++) {
                    colQty += takeStockProducts[i].bNum || 0;
                    colAmt += takeStockProducts[i].totalPrice || 0;
                }
                totalData.push('合计', '', colQty, '', colAmt);
                if (col < columnsInThisPage - 1) totalData.push('');
            }
            const totalRow = worksheet.addRow(totalData);
            totalRow.height = 19;
            totalRow.eachCell((cell, colNumber) => {
                const colInGroup = (colNumber - 1) % (headerCount + 1);
                if (colInGroup === headerCount) return;
                cell.font = { bold: true, size: 11, name: '微软雅黑' };
                if (colInGroup === 0) {
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                } else if (colInGroup === 2) {
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                } else if (colInGroup === 3 || colInGroup === 4) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                    if (typeof cell.value === 'number') cell.numFmt = '#,##0.00';
                }
                if (showBorder) {
                    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                }
            });
            currentRow++;

            // ===== 6. 签名行（关键修改：不分两列，横跨整页只一行）=====
            // ===== 6. 签名行（横跨整页，左中右三段合并）=====
            if (page === pages - 1) {
                // 空行
                worksheet.addRow([]);
                currentRow++;

                // 签名行高度
                const signRow = worksheet.addRow([]);
                signRow.height = 22;

                // 把整行按 3 段合并：左 / 中 / 右
                // 段1：会计（第1列 ~ 约占1/3）
                const seg1End = Math.floor(totalColumnsInPage / 3);
                // 段2：复核（1/3 ~ 2/3）
                const seg2End = Math.floor((totalColumnsInPage * 2) / 3);

                // 合并左段
                worksheet.mergeCells(currentRow, 1, currentRow, Math.max(seg1End, 1));
                const cellLeft = worksheet.getCell(currentRow, 1);
                cellLeft.value = '会计：';
                cellLeft.font = { size: 10, name: '微软雅黑' };
                cellLeft.alignment = { vertical: 'middle', horizontal: 'left' };

                // 合并中段
                worksheet.mergeCells(currentRow, seg1End + 1, currentRow, seg2End);
                const cellMid = worksheet.getCell(currentRow, seg1End + 1);
                cellMid.value = `复核：${recheckUserName || ''}`;
                cellMid.font = { size: 10, name: '微软雅黑' };
                cellMid.alignment = { vertical: 'middle', horizontal: 'center' };

                // 合并右段
                worksheet.mergeCells(currentRow, seg2End + 1, currentRow, totalColumnsInPage);
                const cellRight = worksheet.getCell(currentRow, seg2End + 1);
                cellRight.value = `实物负责人：${userName || ''}`;
                cellRight.font = { size: 10, name: '微软雅黑' };
                cellRight.alignment = { vertical: 'middle', horizontal: 'right' };

                currentRow++;
            }
        }

        // ===== 自动调整列宽 =====
        if (autoWidth) {
            for (let i = 1; i <= 100; i++) {
                const colLetter = getExcelColumn(i);
                const col = worksheet.getColumn(colLetter);
                if (!col.values || col.values.length === 0) break;
                const colInGroup = (i - 1) % (headerCount + 1);
                if (colInGroup === headerCount) {
                    col.width = 2;
                } else if (colInGroup === 0) {
                    col.width = 16;
                } else if (colInGroup === 1) {
                    col.width = 5;
                } else if (colInGroup === 2) {
                    col.width = 8;
                } else if (colInGroup === 3) {
                    col.width = 8;
                } else if (colInGroup === 4) {
                    col.width = 10;
                }
            }
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        FileSaver.saveAs(blob, fileName);
        console.log(`Excel文件已生成: ${fileName}`);
        return true;
    }
    if (apiId === "membershipTransactionDetails") {

        console.log(apiId, queryCriteria);


        let { consumptionTime, contactNumber } = queryCriteria;
        consumptionTime = consumptionTime ? `${dayjs(consumptionTime[0]).format("YYYY-MM-DD")}-${dayjs(consumptionTime[1]).format("YYYY-MM-DD")}` : "所有";
        contactNumber = contactNumber ? contactNumber : "所有";


        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('会员交易', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });


        let newData = rows.map((item: any) => {
            return {
                ...item,
                currentBalance: item.currentBalance + item.currentGifts,
                successfulDate: dayjs(item.successfulDate).format("YYYY-MM-DD"),
                pointsChange: `${item.pointsChange > 0 ? item.pointsChange : ""}${item.consumptionpointsChange < 0 ? `;${item.consumptionpointsChange}(-${item.pointsRedeemAmount})` : ""}`,
                membership: item.membership.id,
            }
        })
        // 1. 解析表头层级

        let columns = [

            { header: '会员号', width: 25, key: "membership", },
            { header: '姓名', width: 13, key: "membershipName", },
            { header: '手机号', width: 15, key: "contactNumber", },
            { header: '首充门店', width: 15, key: "firstBranchStoreName" },
            { header: '实收', width: 10, key: "balanceChange", },
            { header: '赠送', width: 10, key: "giftsChange", },
            { header: '积分', width: 10, key: "pointsChange", },
            { header: '交易时间', width: 15, key: "successfulDate", },
            { header: '合计', width: 10, key: "consumption", },
            { header: '余额', width: 10, key: "currentBalance", },
            { header: '操作门店', width: 15, key: "branchStoreName", },
            { header: '交易类型', width: 10, key: "membershipTransactionTypeName", },






        ]
        worksheet.columns = columns;
        // 添加表头行

        worksheet.addRows(newData);
        worksheet.insertRow(1, [`日期:${consumptionTime}`, '', '', '', `号码:${contactNumber}`, '', '',]);
        worksheet.insertRow(1, ["交易明细"]);


        /**合并单元格 */
        worksheet.mergeCells(`A1`, `${String.fromCharCode(columns.length + 64)}1`);
        worksheet.mergeCells(`A2`, `D2`);
        worksheet.mergeCells(`E2`, `${String.fromCharCode(columns.length + 64)}2`);








        worksheet.eachRow(function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {


                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 15, name: 'Arial', };
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }

        });
        // 生成文件...
        // let sumEnd = rows.length + 6;
        // let finallyRow = worksheet.getRow(sumEnd);

        // finallyRow.getCell(1).value = `制表人:${userName}`; // A1 的值设置为"收货统计表"
        // finallyRow.getCell(3).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;
        // finallyRow.border = {};
        // finallyRow.getCell(1).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        // finallyRow.getCell(3).alignment = { vertical: "middle", horizontal: "right", wrapText: true };

        // worksheet.mergeCells(`A${sumEnd}:B${sumEnd}`)
        // worksheet.mergeCells(`C${sumEnd}:${String.fromCharCode(parentRow.length + 64)}${sumEnd}`)

        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '会员交易.xlsx');
        })

    }
    if (apiId === "enBuyPurStatistics") {
        const { date } = queryCriteria;

        const workbook = new ExcelJS.Workbook();
        workbook.creator = "收货采购统计表";
        workbook.created = new Date();

        const ws = workbook.addWorksheet("收货采购统计表");

        ws.getColumn(1).width = 28;
        ws.getColumn(2).width = 24;
        ws.getColumn(3).width = 16;

        // ===== 第1行：大标题 =====
        ws.addRow(["收货采购统计表"]);
        ws.mergeCells("A1:C1");
        ws.getCell("A1").font = { size: 18, bold: true, name: "Microsoft YaHei", color: { argb: "FF1A1A2E" } };
        ws.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
        ws.getRow(1).height = 38;

        // ===== 第2行：时间范围 =====
        ws.addRow([`时间：${date}`]);
        ws.mergeCells("A2:C2");
        ws.getCell("A2").font = { size: 11, name: "Microsoft YaHei", color: { argb: "FF888888" } };
        ws.getCell("A2").alignment = { horizontal: "left", vertical: "middle" };
        ws.getRow(2).height = 24;

        // ===== 第3行：表头 =====
        const headerRow = ws.addRow(["供应商(采购)", "分店", "金额"]);
        ws.getRow(3).height = 28;
        headerRow.eachCell(cell => {
            cell.font = { bold: true, size: 12, name: "Microsoft YaHei", color: { argb: "FFFFFFFF" } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1890FF" } };
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.border = { top: { style: "thin" }, bottom: { style: "thin" }, left: { style: "thin" }, right: { style: "thin" } };
        });

        // ===== 数据行 =====
        let rowNum = 4;
        rows.forEach((item: any) => {
            const row = ws.getRow(rowNum);
            row.height = 24;

            if (item.isTotalRow) {
                // 第1步：先写值（合并前）
                row.getCell(1).value = "合计";     // A列
                row.getCell(2).value = "";         // B列
                row.getCell(3).value = item.amount; // C列

                // 第2步：再合并
                ws.mergeCells(rowNum, 1, rowNum, 2);

                // 第3步：合并后通过 ws.getCell() 重新获取设样式
                const c1 = ws.getCell(rowNum, 1);
                c1.font = { bold: true, size: 11, name: "Microsoft YaHei", color: { argb: "FFD48806" } };
                c1.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFBE6" } };
                c1.alignment = { horizontal: "center", vertical: "middle" };
                c1.border = {
                    top: { style: "medium", color: { argb: "FFD48806" } },
                    bottom: { style: "medium", color: { argb: "FFD48806" } },
                    left: { style: "medium", color: { argb: "FFD48806" } },
                    right: { style: "medium", color: { argb: "FFD48806" } }
                };

                // C列单独设
                const c3 = ws.getCell(rowNum, 3);
                c3.font = { bold: true, size: 11, name: "Microsoft YaHei", color: { argb: "FFD48806" } };
                c3.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFBE6" } };
                c3.alignment = { horizontal: "center", vertical: "middle" };
                c3.border = {
                    top: { style: "medium", color: { argb: "FFD48806" } },
                    bottom: { style: "medium", color: { argb: "FFD48806" } },
                    left: { style: "medium", color: { argb: "FFD48806" } },
                    right: { style: "medium", color: { argb: "FFD48806" } }
                };
            } else if (item.rowSpan > 0) {
                // ===== 供应商首行 =====
                row.getCell(1).value = item.buyerName;     // A列
                row.getCell(2).value = item.entrepotName;   // B列
                row.getCell(3).value = item.amount;         // C列

                // 合并供应商列（A列），rowSpan - 1 是因为合计行自己合并A+B
                const mergeCount = item.rowSpan - 1;
                if (mergeCount > 1) {
                    ws.mergeCells(rowNum, 1, rowNum + mergeCount - 1, 1);
                }

                row.eachCell(cell => {
                    cell.font = { size: 11, name: "Microsoft YaHei", color: { argb: "FF333333" } };
                    cell.alignment = { horizontal: "center", vertical: "middle" };
                    cell.border = { top: { style: "thin", color: { argb: "FFD9D9D9" } }, bottom: { style: "thin", color: { argb: "FFD9D9D9" } }, left: { style: "thin", color: { argb: "FFD9D9D9" } }, right: { style: "thin", color: { argb: "FFD9D9D9" } } };
                });

            } else {
                // ===== 普通分店行 =====
                row.getCell(2).value = item.entrepotName;
                row.getCell(3).value = item.amount;

                row.eachCell(cell => {
                    cell.font = { size: 11, name: "Microsoft YaHei", color: { argb: "FF555555" } };
                    cell.alignment = { horizontal: "center", vertical: "middle" };
                    cell.border = { top: { style: "thin", color: { argb: "FFD9D9D9" } }, bottom: { style: "thin", color: { argb: "FFD9D9D9" } }, left: { style: "thin", color: { argb: "FFD9D9D9" } }, right: { style: "thin", color: { argb: "FFD9D9D9" } } };
                });
            }

            row.getCell(3).numFmt = "0.00";
            rowNum++;
        });

        // ===== 总计行 =====
        const totalAmount = rows.filter((d: any) => d.isTotalRow).reduce((s: any, d: any) => s + d.amount, 0);
        const grandRow = ws.addRow(["总计", "", totalAmount]);
        ws.mergeCells(rowNum, 1, rowNum, 2);
        grandRow.eachCell(cell => {
            cell.font = { bold: true, size: 12, name: "Microsoft YaHei", color: { argb: "FF1677FF" } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE6F7FF" } };
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.border = { top: { style: "medium", color: { argb: "FF1677FF" } }, bottom: { style: "medium", color: { argb: "FF1677FF" } }, left: { style: "medium", color: { argb: "FF1677FF" } }, right: { style: "medium", color: { argb: "FF1677FF" } } };
        });
        grandRow.getCell(3).numFmt = "0.00";

        // ===== 导出 =====
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            FileSaver.saveAs(blob, `收货采购统计表.xlsx`);
        });
    }

    if (apiId === "costPurOrderQuery") {
        let { time } = queryCriteria;
        time = time ? `${time.startTime}-${time.endTime}` : "所有";

        // 创建工作簿
        var workbook = new ExcelJS.Workbook();
        //添加工作表
        const worksheet = workbook.addWorksheet('收货商品', {
            pageSetup: { paperSize: 9, orientation: 'portrait' }   // 纵向：portrait  横向：landscape； paperSize：9为A4纸、8为A3纸、11为A5纸 具体可查看 https://github.com/exceljs/exceljs/blob/master/README_zh.md#页面设置
        });

        // 1. 解析表头层级

        let columns = [
            { header: '日期', width: 15, key: "createdAt" },

            { header: '产品', width: 15, key: "productName" },
            { header: '单位', width: 15, key: "productUnitName", },
            { header: '规格', width: 15, key: "productSpecifications", },
            { header: '数量', width: 15, key: "bNum", },
            { header: '单价', width: 15, key: "univalence" },
            { header: '金额', width: 15, key: "totalPrice", },
            { header: '备注', width: 15, key: "memo", },
        ]
        worksheet.columns = columns;
        // 添加表头行

        worksheet.addRows(rows);
        worksheet.insertRow(1, ["收货商品"]);


        /**合并单元格 */
        worksheet.mergeCells(`A1`, `${String.fromCharCode(columns.length + 64)}1`);









        worksheet.eachRow(function (row, rowNumber) {
            row.eachCell({ includeEmpty: true }, (cell, rowNumber) => {


                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                cell.font = { size: 12, name: 'Arial' };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };

            })
            if (rowNumber === 1) {
                row.font = { size: 16, name: 'Arial', bold: true };
                row.height = 40;
                row.alignment = { horizontal: 'center', vertical: 'middle' };
            } else if (rowNumber === 2) {
                row.font = { size: 15, name: 'Arial', };
                row.alignment = { horizontal: 'left', vertical: 'middle' };
            }

        });
        // 生成文件...
        // let sumEnd = rows.length + 6;
        // let finallyRow = worksheet.getRow(sumEnd);

        // finallyRow.getCell(1).value = `制表人:${userName}`; // A1 的值设置为"收货统计表"
        // finallyRow.getCell(3).value = `打印时间:${moment().format("YYYY-MM-DD HH:mm:ss")}`;
        // finallyRow.border = {};
        // finallyRow.getCell(1).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        // finallyRow.getCell(3).alignment = { vertical: "middle", horizontal: "right", wrapText: true };

        // worksheet.mergeCells(`A${sumEnd}:B${sumEnd}`)
        // worksheet.mergeCells(`C${sumEnd}:${String.fromCharCode(parentRow.length + 64)}${sumEnd}`)

        workbook.xlsx.writeBuffer().then((item) => {
            const blob = new Blob([item], { type: "EXCEL_TYPE" });
            FileSaver.saveAs(blob, '收货商品.xlsx');
        })

    }

    // 辅助函数：将列号转换为Excel列字母
    function getExcelColumn(colNumber: any) {
        let column = '';
        while (colNumber > 0) {
            const remainder = (colNumber - 1) % 26;
            column = String.fromCharCode(65 + remainder) + column;
            colNumber = Math.floor((colNumber - remainder) / 26);
        }
        return column;
    }
}

export default DownloadExcel;